// This file is auto-generated by @hey-api/openapi-ts

import { client } from "./client.gen.js"
import {
  buildClientParams,
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client/index.js"
import type {
  AgentPartInput,
  AppAgentsResponses,
  AppLlmResponses,
  AppLogErrors,
  AppLogResponses,
  AppSkillsResponses,
  Auth as Auth4,
  AuthRemoveErrors,
  AuthRemoveResponses,
  AuthSetErrors,
  AuthSetResponses,
  CommandListResponses,
  Config as Config3,
  ConfigGetResponses,
  ConfigProvidersResponses,
  ConfigUpdateErrors,
  ConfigUpdateResponses,
  EventSubscribeResponses,
  EventTuiCommandExecute,
  EventTuiPromptAppend,
  EventTuiSessionSelect,
  EventTuiToastShow,
  ExperimentalConsoleGetResponses,
  ExperimentalConsoleListOrgsResponses,
  ExperimentalConsoleSwitchOrgResponses,
  ExperimentalMcpToolsCallErrors,
  ExperimentalMcpToolsCallResponses,
  ExperimentalMcpToolsListErrors,
  ExperimentalMcpToolsListResponses,
  ExperimentalProductSuiteHandleToolsErrors,
  ExperimentalProductSuiteHandleToolsResponses,
  ExperimentalResourceListResponses,
  ExperimentalSessionListResponses,
  ExperimentalWorkspaceAdapterListResponses,
  ExperimentalWorkspaceCreateErrors,
  ExperimentalWorkspaceCreateResponses,
  ExperimentalWorkspaceListResponses,
  ExperimentalWorkspaceRemoveErrors,
  ExperimentalWorkspaceRemoveResponses,
  ExperimentalWorkspaceSessionRestoreErrors,
  ExperimentalWorkspaceSessionRestoreResponses,
  ExperimentalWorkspaceStatusResponses,
  FileListResponses,
  FilePartInput,
  FileReadResponses,
  FileStatusResponses,
  FileWriteResponses,
  FindFilesResponses,
  FindSymbolsResponses,
  FindTextResponses,
  FormatterStatusResponses,
  GlobalAgentRunResponses,
  GlobalAppCredentialsResponses,
  GlobalAppSchedulesDeleteResponses,
  GlobalAppSchedulesListAllResponses,
  GlobalAppSchedulesListResponses,
  GlobalAppSchedulesSaveResponses,
  GlobalAppSchedulesSetEnabledResponses,
  GlobalCapabilitiesResponses,
  GlobalChannelsInboundWhatsappResponses,
  GlobalConfigGetResponses,
  GlobalConfigUpdateErrors,
  GlobalConfigUpdateResponses,
  GlobalDisposeResponses,
  GlobalEntitlementsResponses,
  GlobalEventResponses,
  GlobalHealthResponses,
  GlobalIntegrationsActionsResponses,
  GlobalIntegrationsExecuteResponses,
  GlobalIntegrationsStateResponses,
  GlobalProductSuiteCallResponses,
  GlobalProductSuiteCatalogResponses,
  GlobalProductSuiteCredentialsGetResponses,
  GlobalProductSuiteCredentialsUpdateErrors,
  GlobalProductSuiteCredentialsUpdateResponses,
  GlobalProductSuiteStateResponses,
  GlobalProjectSchedulesDeleteResponses,
  GlobalProjectSchedulesListResponses,
  GlobalProjectSchedulesSaveResponses,
  GlobalProjectSchedulesSetEnabledResponses,
  GlobalProjectWatchersDeleteResponses,
  GlobalProjectWatchersListResponses,
  GlobalProjectWatchersSaveResponses,
  GlobalProjectWatchersSetEnabledResponses,
  GlobalTenxmemoryRuntimeContextClearResponses,
  GlobalTenxmemoryRuntimeContextGetResponses,
  GlobalTenxmemoryRuntimeContextSetErrors,
  GlobalTenxmemoryRuntimeContextSetResponses,
  GlobalUpgradeErrors,
  GlobalUpgradeResponses,
  GlobalWatchEventResponses,
  InstanceDisposeResponses,
  LspStatusResponses,
  McpAddErrors,
  McpAddResponses,
  McpAuthAuthenticateErrors,
  McpAuthAuthenticateResponses,
  McpAuthCallbackErrors,
  McpAuthCallbackResponses,
  McpAuthRemoveErrors,
  McpAuthRemoveResponses,
  McpAuthStartErrors,
  McpAuthStartResponses,
  McpConnectResponses,
  McpDisconnectResponses,
  McpLocalConfig,
  McpRemoteConfig,
  McpStatusResponses,
  OnboardingAuthClearTokenResponses,
  OnboardingAuthSetTokenResponses,
  OrchestratorChannelsInboxErrors,
  OrchestratorChannelsInboxResponses,
  OrchestratorChannelsOutboxErrors,
  OrchestratorChannelsOutboxResponses,
  OrchestratorChannelsStatusErrors,
  OrchestratorChannelsStatusResponses,
  OrchestratorChannelsTicketErrors,
  OrchestratorChannelsTicketResponses,
  OrchestratorDisableErrors,
  OrchestratorDisableResponses,
  OrchestratorEnableErrors,
  OrchestratorEnableResponses,
  OrchestratorLearningsErrors,
  OrchestratorLearningsResponses,
  OrchestratorOfficeEventsErrors,
  OrchestratorOfficeEventsResponses,
  OrchestratorOfficeSnapshotErrors,
  OrchestratorOfficeSnapshotResponses,
  OrchestratorPauseErrors,
  OrchestratorPauseResponses,
  OrchestratorResumeErrors,
  OrchestratorResumeResponses,
  OrchestratorStatusErrors,
  OrchestratorStatusResponses,
  OrchestratorTeamPlanErrors,
  OrchestratorTeamPlanResponses,
  OrchestratorTicketArtifactPromoteErrors,
  OrchestratorTicketArtifactPromoteResponses,
  OrchestratorTicketCapabilityResolveErrors,
  OrchestratorTicketCapabilityResolveResponses,
  OrchestratorTicketCreateErrors,
  OrchestratorTicketCreateResponses,
  OrchestratorTicketGetErrors,
  OrchestratorTicketGetResponses,
  OrchestratorTicketHandoffRetryErrors,
  OrchestratorTicketHandoffRetryResponses,
  OrchestratorTicketListErrors,
  OrchestratorTicketListResponses,
  OrchestratorTicketMemoryPromoteErrors,
  OrchestratorTicketMemoryPromoteResponses,
  OrchestratorTicketRetryErrors,
  OrchestratorTicketRetryResponses,
  OrchestratorTicketTransitionErrors,
  OrchestratorTicketTransitionResponses,
  OrchestratorWorkflowApproveErrors,
  OrchestratorWorkflowApproveResponses,
  OrchestratorWorkflowDraftErrors,
  OrchestratorWorkflowDraftProgressErrors,
  OrchestratorWorkflowDraftProgressResponses,
  OrchestratorWorkflowDraftResponses,
  OrchestratorWorkflowInspectErrors,
  OrchestratorWorkflowInspectResponses,
  OrchestratorWorkflowSourceErrors,
  OrchestratorWorkflowSourceResponses,
  OrchestratorWorkflowSourceUpdateErrors,
  OrchestratorWorkflowSourceUpdateResponses,
  OrchestratorWorkflowValidateErrors,
  OrchestratorWorkflowValidateResponses,
  OutputFormat,
  Part as Part2,
  PartDeleteErrors,
  PartDeleteResponses,
  PartUpdateErrors,
  PartUpdateResponses,
  PathGetResponses,
  PermissionListResponses,
  PermissionReplyErrors,
  PermissionReplyResponses,
  PermissionRespondErrors,
  PermissionRespondResponses,
  PermissionRuleset,
  PluginActionErrors,
  PluginActionResponses,
  PluginAppFileErrors,
  PluginAppFileResponses,
  PluginAppsResponses,
  PluginArtifactActionErrors,
  PluginArtifactActionResponses,
  PluginArtifactActionsResponses,
  PluginCallErrors,
  PluginCallResponses,
  PluginCapabilitiesErrors,
  PluginCapabilitiesResponses,
  PluginCatalogResponses,
  PluginDashboardStateErrors,
  PluginDashboardStateResponses,
  PluginDeleteDashboardWidgetErrors,
  PluginDeleteDashboardWidgetResponses,
  PluginFileAssetErrors,
  PluginFileAssetResponses,
  PluginFileCatalogResponses,
  PluginFileExportErrors,
  PluginFileExportResponses,
  PluginFileInstallResponses,
  PluginFileListErrors,
  PluginFileListResponses,
  PluginFileReadErrors,
  PluginFileReadResponses,
  PluginFileSetEnabledErrors,
  PluginFileSetEnabledResponses,
  PluginFileUninstallResponses,
  PluginFileWriteErrors,
  PluginFileWriteResponses,
  PluginInstalledErrors,
  PluginInstalledResponses,
  PluginInstallErrors,
  PluginInstallOaAppBuilderResponses,
  PluginInstallResponses,
  PluginListDashboardWidgetsErrors,
  PluginListDashboardWidgetsResponses,
  PluginPageErrors,
  PluginPageResponses,
  PluginPartInput,
  PluginReloadResponses,
  PluginRemoveErrors,
  PluginRemoveResponses,
  PluginSubmitErrors,
  PluginSubmitResponses,
  PluginUpdateDashboardStateErrors,
  PluginUpdateDashboardStateResponses,
  PluginUploadErrors,
  PluginUploadResponses,
  PluginUpsertDashboardWidgetErrors,
  PluginUpsertDashboardWidgetResponses,
  ProjectCreateErrors,
  ProjectCreateResponses,
  ProjectCreateStarterErrors,
  ProjectCreateStarterResponses,
  ProjectCurrentResponses,
  ProjectInitGitResponses,
  ProjectListResponses,
  ProjectMarkStructureResponses,
  ProjectStarterResponses,
  ProjectStructureResponses,
  ProjectUpdateErrors,
  ProjectUpdateResponses,
  ProjectUploadErrors,
  ProjectUploadResponses,
  ProjectWorkspaceResponses,
  ProviderAuthResponses,
  ProviderListResponses,
  ProviderOauthAuthorizeErrors,
  ProviderOauthAuthorizeResponses,
  ProviderOauthCallbackErrors,
  ProviderOauthCallbackResponses,
  PtyConnectErrors,
  PtyConnectResponses,
  PtyCreateErrors,
  PtyCreateResponses,
  PtyGetErrors,
  PtyGetResponses,
  PtyListResponses,
  PtyRemoveErrors,
  PtyRemoveResponses,
  PtyShellsResponses,
  PtyUpdateErrors,
  PtyUpdateResponses,
  QuestionAnswer,
  QuestionListResponses,
  QuestionRejectErrors,
  QuestionRejectResponses,
  QuestionReplyErrors,
  QuestionReplyResponses,
  ReflectReportResponses,
  SessionAbortErrors,
  SessionAbortResponses,
  SessionChildrenErrors,
  SessionChildrenResponses,
  SessionCommandErrors,
  SessionCommandResponses,
  SessionCreateErrors,
  SessionCreateResponses,
  SessionDeleteErrors,
  SessionDeleteMessageErrors,
  SessionDeleteMessageResponses,
  SessionDeleteResponses,
  SessionDiffResponses,
  SessionForkResponses,
  SessionGetErrors,
  SessionGetResponses,
  SessionGoalStatusErrors,
  SessionGoalStatusResponses,
  SessionInitErrors,
  SessionInitResponses,
  SessionListResponses,
  SessionMessageErrors,
  SessionMessageResponses,
  SessionMessagesErrors,
  SessionMessagesResponses,
  SessionPromptAsyncErrors,
  SessionPromptAsyncResponses,
  SessionPromptErrors,
  SessionPromptResponses,
  SessionRevertErrors,
  SessionRevertResponses,
  SessionShareErrors,
  SessionShareResponses,
  SessionShellErrors,
  SessionShellResponses,
  SessionStatusErrors,
  SessionStatusResponses,
  SessionSummarizeErrors,
  SessionSummarizeResponses,
  SessionTodoErrors,
  SessionTodoResponses,
  SessionUnrevertErrors,
  SessionUnrevertResponses,
  SessionUnshareErrors,
  SessionUnshareResponses,
  SessionUpdateErrors,
  SessionUpdateResponses,
  SkillPartInput,
  SubtaskPartInput,
  SyncHistoryListErrors,
  SyncHistoryListResponses,
  SyncReplayErrors,
  SyncReplayResponses,
  SyncStartResponses,
  TextPartInput,
  ToolIdsErrors,
  ToolIdsResponses,
  ToolListErrors,
  ToolListResponses,
  TranscriptionRequest,
  TranscriptionTranscribeErrors,
  TranscriptionTranscribeResponses,
  TuiAppendPromptErrors,
  TuiAppendPromptResponses,
  TuiClearPromptResponses,
  TuiControlNextResponses,
  TuiControlResponseResponses,
  TuiExecuteCommandErrors,
  TuiExecuteCommandResponses,
  TuiOpenHelpResponses,
  TuiOpenModelsResponses,
  TuiOpenSessionsResponses,
  TuiOpenThemesResponses,
  TuiPublishErrors,
  TuiPublishResponses,
  TuiSelectSessionErrors,
  TuiSelectSessionResponses,
  TuiShowToastResponses,
  TuiSubmitPromptResponses,
  VcsDiffResponses,
  VcsGetResponses,
  WorktreeCreateErrors,
  WorktreeCreateInput,
  WorktreeCreateResponses,
  WorktreeListResponses,
  WorktreeRemoveErrors,
  WorktreeRemoveInput,
  WorktreeRemoveResponses,
  WorktreeResetErrors,
  WorktreeResetInput,
  WorktreeResetResponses,
} from "./types.gen.js"

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

class HeyApiClient {
  protected client: Client

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client
  }
}

class HeyApiRegistry<T> {
  private readonly defaultKey = "default"

  private readonly instances: Map<string, T> = new Map()

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey)
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new OpenAnalystClient()" to fix this error.`)
    }
    return instance
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value)
  }
}

export class Integrations extends HeyApiClient {
  /**
   * The user's connected integration providers
   *
   * Active MCP integration providers (gmail, instagram, …), lower-cased, so an app can gate event creation on the integration an event needs being connected. `known:false` = could not determine; fail open.
   */
  public state<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).get<GlobalIntegrationsStateResponses, unknown, ThrowOnError>({
      url: "/global/integrations/state",
      ...options,
    })
  }

  /**
   * The actions a connected provider exposes, for a declaring app
   */
  public actions<ThrowOnError extends boolean = false>(
    parameters: {
      app?: string
      provider: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "app" },
            { in: "query", key: "provider" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<GlobalIntegrationsActionsResponses, unknown, ThrowOnError>({
      url: "/global/integrations/actions",
      ...options,
      ...params,
    })
  }

  /**
   * Run one integration action on the user's connected account, for a declaring app
   */
  public execute<ThrowOnError extends boolean = false>(
    parameters?: {
      app?: string
      action?: string
      params?: {
        [key: string]: unknown
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "app" },
            { in: "body", key: "action" },
            { in: "body", key: "params" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalIntegrationsExecuteResponses, unknown, ThrowOnError>({
      url: "/global/integrations/execute",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Agent extends HeyApiClient {
  /**
   * Run one engine agent turn in a project, for an app sidecar
   *
   * Reachable with the sidecar's Basic OA_ENGINE_TOKEN. Runs the real agent loop under an enforced tool policy, on the user's models/credits, in `directory`, and returns the assistant's final text.
   */
  public run<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      prompt?: string
      apps?: Array<string>
      system?: string
      title?: string
      policy?: "full" | "read_only" | "read_only_web" | "intake"
      sessionID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "prompt" },
            { in: "body", key: "apps" },
            { in: "body", key: "system" },
            { in: "body", key: "title" },
            { in: "body", key: "policy" },
            { in: "body", key: "sessionID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalAgentRunResponses, unknown, ThrowOnError>({
      url: "/global/agent/run",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Inbound extends HeyApiClient {
  /**
   * Channel inbound: dispatch a self-chat message before the assistant's own turn
   *
   * Reachable only with the channel inbound Bearer (not the engine password). Runs the deterministic reply grammar against the project's pending tickets; returns `{consumed, reply?}`.
   */
  public whatsapp<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      envelope?: {
        chat_id: string
        sender_ref: string
        own_jid: string
        message_id: string
        text: string
        reply_to_message_id?: string | null
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "envelope" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalChannelsInboundWhatsappResponses, unknown, ThrowOnError>({
      url: "/global/channels/inbound/whatsapp",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Channels extends HeyApiClient {
  private _inbound?: Inbound
  get inbound(): Inbound {
    return (this._inbound ??= new Inbound({ client: this.client }))
  }
}

export class ProjectSchedules extends HeyApiClient {
  /**
   * The project's own schedules (not owned by any app)
   */
  public list<ThrowOnError extends boolean = false>(
    parameters: {
      directory: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "query", key: "directory" }] }])
    return (options?.client ?? this.client).get<GlobalProjectSchedulesListResponses, unknown, ThrowOnError>({
      url: "/global/project-schedules",
      ...options,
      ...params,
    })
  }

  /**
   * Create or update a project-level schedule
   */
  public save<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      name?: string
      cron?: string
      prompt?: string
      apps?: Array<string>
      integrations?: Array<string>
      id?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "name" },
            { in: "body", key: "cron" },
            { in: "body", key: "prompt" },
            { in: "body", key: "apps" },
            { in: "body", key: "integrations" },
            { in: "body", key: "id" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalProjectSchedulesSaveResponses, unknown, ThrowOnError>({
      url: "/global/project-schedules/save",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Pause or resume a project-level schedule
   */
  public setEnabled<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      id?: string
      enabled?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "id" },
            { in: "body", key: "enabled" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalProjectSchedulesSetEnabledResponses, unknown, ThrowOnError>({
      url: "/global/project-schedules/enabled",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Delete a project-level schedule
   */
  public delete<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      id?: string
      source?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "id" },
            { in: "body", key: "source" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalProjectSchedulesDeleteResponses, unknown, ThrowOnError>({
      url: "/global/project-schedules/delete",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class AppSchedules extends HeyApiClient {
  /**
   * A plugin app's own schedules
   */
  public list<ThrowOnError extends boolean = false>(
    parameters: {
      directory: string
      appId: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "appId" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<GlobalAppSchedulesListResponses, unknown, ThrowOnError>({
      url: "/global/app-schedules",
      ...options,
      ...params,
    })
  }

  /**
   * Every installed app's schedules for a project
   */
  public listAll<ThrowOnError extends boolean = false>(
    parameters: {
      directory: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "query", key: "directory" }] }])
    return (options?.client ?? this.client).get<GlobalAppSchedulesListAllResponses, unknown, ThrowOnError>({
      url: "/global/app-schedules/all",
      ...options,
      ...params,
    })
  }

  /**
   * Create or update a plugin app's schedule
   */
  public save<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      appId?: string
      name?: string
      cron?: string
      prompt?: string
      apps?: Array<string>
      integrations?: Array<string>
      notify?: string
      id?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "appId" },
            { in: "body", key: "name" },
            { in: "body", key: "cron" },
            { in: "body", key: "prompt" },
            { in: "body", key: "apps" },
            { in: "body", key: "integrations" },
            { in: "body", key: "notify" },
            { in: "body", key: "id" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalAppSchedulesSaveResponses, unknown, ThrowOnError>({
      url: "/global/app-schedules/save",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Pause or resume a plugin app's schedule
   */
  public setEnabled<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      appId?: string
      id?: string
      enabled?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "appId" },
            { in: "body", key: "id" },
            { in: "body", key: "enabled" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalAppSchedulesSetEnabledResponses, unknown, ThrowOnError>({
      url: "/global/app-schedules/enabled",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Delete a plugin app's schedule
   */
  public delete<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      appId?: string
      id?: string
      source?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "appId" },
            { in: "body", key: "id" },
            { in: "body", key: "source" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalAppSchedulesDeleteResponses, unknown, ThrowOnError>({
      url: "/global/app-schedules/delete",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class ProjectWatchers extends HeyApiClient {
  /**
   * The project's own watchers (event-triggered automations)
   */
  public list<ThrowOnError extends boolean = false>(
    parameters: {
      directory: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "query", key: "directory" }] }])
    return (options?.client ?? this.client).get<GlobalProjectWatchersListResponses, unknown, ThrowOnError>({
      url: "/global/project-watchers",
      ...options,
      ...params,
    })
  }

  /**
   * Create or update a project-level watcher
   */
  public save<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      name?: string
      watch?: string
      prompt?: string
      id?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "name" },
            { in: "body", key: "watch" },
            { in: "body", key: "prompt" },
            { in: "body", key: "id" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalProjectWatchersSaveResponses, unknown, ThrowOnError>({
      url: "/global/project-watchers/save",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Pause (stop) or resume a project-level watcher
   */
  public setEnabled<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      id?: string
      enabled?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "id" },
            { in: "body", key: "enabled" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalProjectWatchersSetEnabledResponses, unknown, ThrowOnError>({
      url: "/global/project-watchers/enabled",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Delete a project-level watcher
   */
  public delete<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      id?: string
      source?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "directory" },
            { in: "body", key: "id" },
            { in: "body", key: "source" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalProjectWatchersDeleteResponses, unknown, ThrowOnError>({
      url: "/global/project-watchers/delete",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Watch extends HeyApiClient {
  /**
   * Deliver a connected-app event to matching watchers
   */
  public event<ThrowOnError extends boolean = false>(
    parameters?: {
      key?: string
      payload?: unknown
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "key" },
            { in: "body", key: "payload" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalWatchEventResponses, unknown, ThrowOnError>({
      url: "/global/watch/event",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Config extends HeyApiClient {
  /**
   * Get global configuration
   *
   * Retrieve the current global OpenAnalyst configuration settings and preferences.
   */
  public get<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).get<GlobalConfigGetResponses, unknown, ThrowOnError>({
      url: "/global/config",
      ...options,
    })
  }

  /**
   * Update global configuration
   *
   * Update global OpenAnalyst configuration settings and preferences.
   */
  public update<ThrowOnError extends boolean = false>(
    parameters?: {
      config?: Config3
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ key: "config", map: "body" }] }])
    return (options?.client ?? this.client).patch<GlobalConfigUpdateResponses, GlobalConfigUpdateErrors, ThrowOnError>({
      url: "/global/config",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class RuntimeContext extends HeyApiClient {
  /**
   * Clear 10x control-plane runtime context
   *
   * Clear the active 10x control-plane runtime context from the local sidecar.
   */
  public clear<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).delete<GlobalTenxmemoryRuntimeContextClearResponses, unknown, ThrowOnError>(
      { url: "/global/tenxmemory/runtime-context", ...options },
    )
  }

  /**
   * Get 10x control-plane runtime context status
   *
   * Return redacted status for the active 10x control-plane runtime context.
   */
  public get<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).get<GlobalTenxmemoryRuntimeContextGetResponses, unknown, ThrowOnError>({
      url: "/global/tenxmemory/runtime-context",
      ...options,
    })
  }

  /**
   * Set 10x control-plane runtime context
   *
   * Store the active 10x control-plane runtime context for the local sidecar without returning secrets.
   */
  public set<ThrowOnError extends boolean = false>(
    parameters?: {
      baseURL?: string
      handle?: string
      handles?: Array<
        | string
        | {
            handle: string
            handleDisplay?: string | null
            accessRole?: string | null
            enabled?: boolean
            disabled?: boolean
            status?: string | null
            state?: string | null
          }
      >
      token?: string
      pat?: string
      projectId?: string
      projectName?: string
      workspaceId?: string
      workspaceName?: string
      workspacePath?: string
      localRuntimeUrl?: string
      smartworkToken?: string
      openAnalystProviderToken?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "baseURL" },
            { in: "body", key: "handle" },
            { in: "body", key: "handles" },
            { in: "body", key: "token" },
            { in: "body", key: "pat" },
            { in: "body", key: "projectId" },
            { in: "body", key: "projectName" },
            { in: "body", key: "workspaceId" },
            { in: "body", key: "workspaceName" },
            { in: "body", key: "workspacePath" },
            { in: "body", key: "localRuntimeUrl" },
            { in: "body", key: "smartworkToken" },
            { in: "body", key: "openAnalystProviderToken" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      GlobalTenxmemoryRuntimeContextSetResponses,
      GlobalTenxmemoryRuntimeContextSetErrors,
      ThrowOnError
    >({
      url: "/global/tenxmemory/runtime-context",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Tenxmemory extends HeyApiClient {
  private _runtimeContext?: RuntimeContext
  get runtimeContext(): RuntimeContext {
    return (this._runtimeContext ??= new RuntimeContext({ client: this.client }))
  }
}

export class Credentials extends HeyApiClient {
  /**
   * Get Product Suite credential status
   *
   * Return redacted ai.openanalyst.com Product Suite credential status, including available handles for plugin apps.
   */
  public get<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).get<GlobalProductSuiteCredentialsGetResponses, unknown, ThrowOnError>({
      url: "/global/product-suite/credentials",
      ...options,
    })
  }

  /**
   * Update Product Suite credentials
   *
   * Patch shared ai.openanalyst.com Product Suite credentials for the local sidecar. Secrets are never returned.
   */
  public update<ThrowOnError extends boolean = false>(
    parameters?: {
      baseURL?: string
      handle?: string
      handles?: Array<
        | string
        | {
            handle: string
            handleDisplay?: string | null
            accessRole?: string | null
            enabled?: boolean
            disabled?: boolean
            status?: string | null
            state?: string | null
          }
      >
      projectPath?: string
      token?: string
      pat?: string | null
      clearPat?: boolean
      clearProjectHandle?: boolean
      removeHandle?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "baseURL" },
            { in: "body", key: "handle" },
            { in: "body", key: "handles" },
            { in: "body", key: "projectPath" },
            { in: "body", key: "token" },
            { in: "body", key: "pat" },
            { in: "body", key: "clearPat" },
            { in: "body", key: "clearProjectHandle" },
            { in: "body", key: "removeHandle" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).patch<
      GlobalProductSuiteCredentialsUpdateResponses,
      GlobalProductSuiteCredentialsUpdateErrors,
      ThrowOnError
    >({
      url: "/global/product-suite/credentials",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class ProductSuite extends HeyApiClient {
  private _credentials?: Credentials
  get credentials(): Credentials {
    return (this._credentials ??= new Credentials({ client: this.client }))
  }
}

export class Global extends HeyApiClient {
  /**
   * Is a capability included in the user's plan?
   *
   * The plan check lives in the ENGINE — it owns the composer, the model call and the account. An app only renders the result, so gating the next capability is a config change here, not a code change in twelve apps. A GATED CAPABILITY IS NOT A FAILURE: the system worked as designed and the user is one click from what they wanted. And the inverse is equally required — a user who IS entitled and hits a real fault gets a real ERROR, because telling someone on Enterprise to upgrade to Enterprise buries a genuine bug behind a sales prompt.
   */
  public entitlements<ThrowOnError extends boolean = false>(
    parameters: {
      capability: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "query", key: "capability" }] }])
    return (options?.client ?? this.client).get<GlobalEntitlementsResponses, unknown, ThrowOnError>({
      url: "/global/entitlements",
      ...options,
      ...params,
    })
  }

  /**
   * The 10X handle + PAT for an app sidecar
   *
   * Resolve the handle bound to a project and its PAT, so the desktop shell can inject them into an app sidecar's PROCESS (OA_10X_HANDLE / OA_10X_PAT). The engine owns this resolution — account keying, the project binding, and the sole-account fallback — so the shell never re-derives it and never gets it subtly wrong. The token is returned to the SHELL, never to a renderer: an app renders web pages it did not write, and a token in a renderer is a token any injected script can read.
   */
  public appCredentials<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "query", key: "directory" }] }])
    return (options?.client ?? this.client).get<GlobalAppCredentialsResponses, unknown, ThrowOnError>({
      url: "/global/app-credentials",
      ...options,
      ...params,
    })
  }

  /**
   * The project's Product Suite connection
   */
  public productSuiteState<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "query", key: "directory" }] }])
    return (options?.client ?? this.client).get<GlobalProductSuiteStateResponses, unknown, ThrowOnError>({
      url: "/global/product-suite/state",
      ...options,
      ...params,
    })
  }

  /**
   * The handle's tools, scoped to the calling app's families
   */
  public productSuiteCatalog<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      app?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "app" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<GlobalProductSuiteCatalogResponses, unknown, ThrowOnError>({
      url: "/global/product-suite/catalog",
      ...options,
      ...params,
    })
  }

  /**
   * Call one platform tool, enforcing the calling app's families
   */
  public productSuiteCall<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      app?: string
      tool?: string
      args?: {
        [key: string]: unknown
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "app" },
            { in: "body", key: "tool" },
            { in: "body", key: "args" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<GlobalProductSuiteCallResponses, unknown, ThrowOnError>({
      url: "/global/product-suite/call",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get health
   *
   * Get health information about the OpenAnalyst server.
   */
  public health<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).get<GlobalHealthResponses, unknown, ThrowOnError>({
      url: "/global/health",
      ...options,
    })
  }

  /**
   * Get runtime capabilities
   *
   * Get hosted runtime feature flags required by the OpenAnalyst web proxy.
   */
  public capabilities<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).get<GlobalCapabilitiesResponses, unknown, ThrowOnError>({
      url: "/global/capabilities",
      ...options,
    })
  }

  /**
   * Get global events
   *
   * Subscribe to global events from the OpenAnalyst system using server-sent events.
   */
  public event<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).sse.get<GlobalEventResponses, unknown, ThrowOnError>({
      url: "/global/event",
      ...options,
    })
  }

  /**
   * Dispose instance
   *
   * Clean up and dispose all OpenAnalyst instances, releasing all resources.
   */
  public dispose<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>) {
    return (options?.client ?? this.client).post<GlobalDisposeResponses, unknown, ThrowOnError>({
      url: "/global/dispose",
      ...options,
    })
  }

  /**
   * Upgrade openanalyst
   *
   * Upgrade openanalyst to the specified version or latest if not specified.
   */
  public upgrade<ThrowOnError extends boolean = false>(
    parameters?: {
      target?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "body", key: "target" }] }])
    return (options?.client ?? this.client).post<GlobalUpgradeResponses, GlobalUpgradeErrors, ThrowOnError>({
      url: "/global/upgrade",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  private _integrations?: Integrations
  get integrations(): Integrations {
    return (this._integrations ??= new Integrations({ client: this.client }))
  }

  private _agent?: Agent
  get agent(): Agent {
    return (this._agent ??= new Agent({ client: this.client }))
  }

  private _channels?: Channels
  get channels(): Channels {
    return (this._channels ??= new Channels({ client: this.client }))
  }

  private _projectSchedules?: ProjectSchedules
  get projectSchedules(): ProjectSchedules {
    return (this._projectSchedules ??= new ProjectSchedules({ client: this.client }))
  }

  private _appSchedules?: AppSchedules
  get appSchedules(): AppSchedules {
    return (this._appSchedules ??= new AppSchedules({ client: this.client }))
  }

  private _projectWatchers?: ProjectWatchers
  get projectWatchers(): ProjectWatchers {
    return (this._projectWatchers ??= new ProjectWatchers({ client: this.client }))
  }

  private _watch?: Watch
  get watch(): Watch {
    return (this._watch ??= new Watch({ client: this.client }))
  }

  private _config?: Config
  get config(): Config {
    return (this._config ??= new Config({ client: this.client }))
  }

  private _tenxmemory?: Tenxmemory
  get tenxmemory(): Tenxmemory {
    return (this._tenxmemory ??= new Tenxmemory({ client: this.client }))
  }

  private _productSuite?: ProductSuite
  get productSuite(): ProductSuite {
    return (this._productSuite ??= new ProductSuite({ client: this.client }))
  }
}

export class App extends HeyApiClient {
  /**
   * Run a model call on the user's account, for an app sidecar
   *
   * An app does NOT hold a model key and does NOT bill its own account. It posts here, and the engine forwards to the gateway with the USER'S provider token — the same path a chat turn takes, so credits are counted once, in one place.\n\nPlan-gated capabilities (vision) are refused HERE with reason:'entitlement' — a refusal that is not a failure. A real fault on an entitled user comes back as reason:'error'.
   */
  public llm<ThrowOnError extends boolean = false>(
    parameters?: {
      model?: string
      messages?: Array<{
        [key: string]: unknown
      }>
      system?: string
      max_tokens?: number
      temperature?: number
      tools?: Array<{
        [key: string]: unknown
      }>
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "body", key: "model" },
            { in: "body", key: "messages" },
            { in: "body", key: "system" },
            { in: "body", key: "max_tokens" },
            { in: "body", key: "temperature" },
            { in: "body", key: "tools" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<AppLlmResponses, unknown, ThrowOnError>({
      url: "/app-llm",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Write log
   *
   * Write a log entry to the server logs with specified level and metadata.
   */
  public log<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      service?: string
      level?: "debug" | "info" | "error" | "warn"
      message?: string
      extra?: {
        [key: string]: unknown
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "service" },
            { in: "body", key: "level" },
            { in: "body", key: "message" },
            { in: "body", key: "extra" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<AppLogResponses, AppLogErrors, ThrowOnError>({
      url: "/log",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * List agents
   *
   * Get a list of all available AI agents in the OpenAnalyst system.
   */
  public agents<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<AppAgentsResponses, unknown, ThrowOnError>({
      url: "/agent",
      ...options,
      ...params,
    })
  }

  /**
   * List skills
   *
   * Get a list of all available skills in the OpenAnalyst system.
   */
  public skills<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<AppSkillsResponses, unknown, ThrowOnError>({
      url: "/skill",
      ...options,
      ...params,
    })
  }
}

export class Auth extends HeyApiClient {
  /**
   * Remove auth credentials
   *
   * Remove authentication credentials
   */
  public remove<ThrowOnError extends boolean = false>(
    parameters: {
      providerID: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams([parameters], [{ args: [{ in: "path", key: "providerID" }] }])
    return (options?.client ?? this.client).delete<AuthRemoveResponses, AuthRemoveErrors, ThrowOnError>({
      url: "/auth/{providerID}",
      ...options,
      ...params,
    })
  }

  /**
   * Set auth credentials
   *
   * Set authentication credentials
   */
  public set<ThrowOnError extends boolean = false>(
    parameters: {
      providerID: string
      auth?: Auth4
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "providerID" },
            { key: "auth", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).put<AuthSetResponses, AuthSetErrors, ThrowOnError>({
      url: "/auth/{providerID}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Adapter extends HeyApiClient {
  /**
   * List workspace adapters
   *
   * List all available workspace adapters for the current project.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ExperimentalWorkspaceAdapterListResponses, unknown, ThrowOnError>({
      url: "/experimental/workspace/adapter",
      ...options,
      ...params,
    })
  }
}

export class Workspace extends HeyApiClient {
  /**
   * List workspaces
   *
   * List all workspaces.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ExperimentalWorkspaceListResponses, unknown, ThrowOnError>({
      url: "/experimental/workspace",
      ...options,
      ...params,
    })
  }

  /**
   * Create workspace
   *
   * Create a workspace for the current project.
   */
  public create<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      id?: string
      type?: string
      branch?: string | null
      extra?: unknown | null
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "id" },
            { in: "body", key: "type" },
            { in: "body", key: "branch" },
            { in: "body", key: "extra" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      ExperimentalWorkspaceCreateResponses,
      ExperimentalWorkspaceCreateErrors,
      ThrowOnError
    >({
      url: "/experimental/workspace",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Workspace status
   *
   * Get connection status for workspaces in the current project.
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ExperimentalWorkspaceStatusResponses, unknown, ThrowOnError>({
      url: "/experimental/workspace/status",
      ...options,
      ...params,
    })
  }

  /**
   * Remove workspace
   *
   * Remove an existing workspace.
   */
  public remove<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<
      ExperimentalWorkspaceRemoveResponses,
      ExperimentalWorkspaceRemoveErrors,
      ThrowOnError
    >({
      url: "/experimental/workspace/{id}",
      ...options,
      ...params,
    })
  }

  /**
   * Restore session into workspace
   *
   * Replay a session's sync events into the target workspace in batches.
   */
  public sessionRestore<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
      sessionID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "sessionID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      ExperimentalWorkspaceSessionRestoreResponses,
      ExperimentalWorkspaceSessionRestoreErrors,
      ThrowOnError
    >({
      url: "/experimental/workspace/{id}/session-restore",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  private _adapter?: Adapter
  get adapter(): Adapter {
    return (this._adapter ??= new Adapter({ client: this.client }))
  }
}

export class ProductSuite2 extends HeyApiClient {
  /**
   * List Product Suite handle MCP tools
   *
   * List the redacted tool names available through a saved PAT for one 10X handle. Secrets are never returned.
   */
  public handleTools<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      handle: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "handle" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      ExperimentalProductSuiteHandleToolsResponses,
      ExperimentalProductSuiteHandleToolsErrors,
      ThrowOnError
    >({
      url: "/experimental/product-suite/handle-tools",
      ...options,
      ...params,
    })
  }
}

export class Console extends HeyApiClient {
  /**
   * Get active Console provider metadata
   *
   * Get the active Console org name and the set of provider IDs managed by that Console org.
   */
  public get<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ExperimentalConsoleGetResponses, unknown, ThrowOnError>({
      url: "/experimental/console",
      ...options,
      ...params,
    })
  }

  /**
   * List switchable Console orgs
   *
   * Get the available Console orgs across logged-in accounts, including the current active org.
   */
  public listOrgs<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ExperimentalConsoleListOrgsResponses, unknown, ThrowOnError>({
      url: "/experimental/console/orgs",
      ...options,
      ...params,
    })
  }

  /**
   * Switch active Console org
   *
   * Persist a new active Console account/org selection for the current local OpenAnalyst state.
   */
  public switchOrg<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      accountID?: string
      orgID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "accountID" },
            { in: "body", key: "orgID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<ExperimentalConsoleSwitchOrgResponses, unknown, ThrowOnError>({
      url: "/experimental/console/switch",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Tools extends HeyApiClient {
  /**
   * List connected MCP tools
   *
   * Get connected MCP tools, optionally filtered by MCP server name.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      server?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "server" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      ExperimentalMcpToolsListResponses,
      ExperimentalMcpToolsListErrors,
      ThrowOnError
    >({
      url: "/experimental/mcp/tools",
      ...options,
      ...params,
    })
  }

  /**
   * Call a connected MCP tool
   *
   * Execute one connected MCP tool by key, optionally constrained to a server prefix.
   */
  public call<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      server?: string
      key?: string
      args?: {
        [key: string]: unknown
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "server" },
            { in: "body", key: "key" },
            { in: "body", key: "args" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      ExperimentalMcpToolsCallResponses,
      ExperimentalMcpToolsCallErrors,
      ThrowOnError
    >({
      url: "/experimental/mcp/tools/call",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Mcp extends HeyApiClient {
  private _tools?: Tools
  get tools(): Tools {
    return (this._tools ??= new Tools({ client: this.client }))
  }
}

export class Session extends HeyApiClient {
  /**
   * List sessions
   *
   * Get a list of all OpenAnalyst sessions across projects, sorted by most recently updated. Archived sessions are excluded by default.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      roots?: boolean | "true" | "false"
      start?: number
      cursor?: number
      search?: string
      limit?: number
      archived?: boolean | "true" | "false"
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "roots" },
            { in: "query", key: "start" },
            { in: "query", key: "cursor" },
            { in: "query", key: "search" },
            { in: "query", key: "limit" },
            { in: "query", key: "archived" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ExperimentalSessionListResponses, unknown, ThrowOnError>({
      url: "/experimental/session",
      ...options,
      ...params,
    })
  }
}

export class Resource extends HeyApiClient {
  /**
   * Get MCP resources
   *
   * Get all available MCP resources from connected servers. Optionally filter by name.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ExperimentalResourceListResponses, unknown, ThrowOnError>({
      url: "/experimental/resource",
      ...options,
      ...params,
    })
  }
}

export class Experimental extends HeyApiClient {
  private _workspace?: Workspace
  get workspace(): Workspace {
    return (this._workspace ??= new Workspace({ client: this.client }))
  }

  private _productSuite?: ProductSuite2
  get productSuite(): ProductSuite2 {
    return (this._productSuite ??= new ProductSuite2({ client: this.client }))
  }

  private _console?: Console
  get console(): Console {
    return (this._console ??= new Console({ client: this.client }))
  }

  private _mcp?: Mcp
  get mcp(): Mcp {
    return (this._mcp ??= new Mcp({ client: this.client }))
  }

  private _session?: Session
  get session(): Session {
    return (this._session ??= new Session({ client: this.client }))
  }

  private _resource?: Resource
  get resource(): Resource {
    return (this._resource ??= new Resource({ client: this.client }))
  }
}

export class Project extends HeyApiClient {
  /**
   * List all projects
   *
   * Get a list of projects that have been opened with OpenAnalyst.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ProjectListResponses, unknown, ThrowOnError>({
      url: "/project",
      ...options,
      ...params,
    })
  }

  /**
   * List workspace projects
   *
   * List project directories inside OPENANALYST_START_DIR for hosted web runtimes.
   */
  public workspace<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ProjectWorkspaceResponses, unknown, ThrowOnError>({
      url: "/project/workspace",
      ...options,
      ...params,
    })
  }

  /**
   * Create workspace project
   *
   * Create a project directory inside OPENANALYST_START_DIR for hosted web runtimes.
   */
  public create<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      name?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "name" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<ProjectCreateResponses, ProjectCreateErrors, ThrowOnError>({
      url: "/project/create",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get project starter panel
   *
   * Return memory-curated starter cards for the current project.
   */
  public starter<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      surface?: "session"
      limit?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "surface" },
            { in: "query", key: "limit" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ProjectStarterResponses, unknown, ThrowOnError>({
      url: "/project/starter",
      ...options,
      ...params,
    })
  }

  /**
   * Create starter workspace project
   *
   * Create a trusted starter project inside OPENANALYST_START_DIR for hosted web runtimes.
   */
  public createStarter<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      templateId?: string
      requestId?: string
      binding?: {
        handle: string
        workspace: string
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "templateId" },
            { in: "body", key: "requestId" },
            { in: "body", key: "binding" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      ProjectCreateStarterResponses,
      ProjectCreateStarterErrors,
      ThrowOnError
    >({
      url: "/project/starter",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Upload workspace project
   *
   * Create a hosted project directory and upload browser-selected folder files into it.
   */
  public upload<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      name?: string
      path?: Array<string>
      file?: Array<Blob | File>
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "name" },
            { in: "body", key: "path" },
            { in: "body", key: "file" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<ProjectUploadResponses, ProjectUploadErrors, ThrowOnError>({
      ...formDataBodySerializer,
      url: "/project/upload",
      ...options,
      ...params,
      headers: {
        "Content-Type": null,
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get current project
   *
   * Retrieve the currently active project that OpenAnalyst is working with.
   */
  public current<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ProjectCurrentResponses, unknown, ThrowOnError>({
      url: "/project/current",
      ...options,
      ...params,
    })
  }

  /**
   * Get project structure
   *
   * Return the OpenAnalyst workspace structure marker state for the current project.
   */
  public structure<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ProjectStructureResponses, unknown, ThrowOnError>({
      url: "/project/structure",
      ...options,
      ...params,
    })
  }

  /**
   * Mark project as OpenAnalyst workspace
   *
   * Create the default OpenAnalyst workspace marker and missing skeleton folders without overwriting files.
   */
  public markStructure<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<ProjectMarkStructureResponses, unknown, ThrowOnError>({
      url: "/project/structure/mark",
      ...options,
      ...params,
    })
  }

  /**
   * Initialize git repository
   *
   * Create a git repository for the current project and return the refreshed project info.
   */
  public initGit<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<ProjectInitGitResponses, unknown, ThrowOnError>({
      url: "/project/git/init",
      ...options,
      ...params,
    })
  }

  /**
   * Update project
   *
   * Update project properties such as name, icon, and commands.
   */
  public update<ThrowOnError extends boolean = false>(
    parameters: {
      projectID: string
      directory?: string
      workspace?: string
      name?: string
      icon?: {
        url?: string
        override?: string
        color?: string
      }
      commands?: {
        /**
         * Startup script to run when creating a new workspace (worktree)
         */
        start?: string
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "projectID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "name" },
            { in: "body", key: "icon" },
            { in: "body", key: "commands" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).patch<ProjectUpdateResponses, ProjectUpdateErrors, ThrowOnError>({
      url: "/project/{projectID}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Reflect extends HeyApiClient {
  /**
   * Reflect report
   *
   * A recap of how this machine has been used over a range: conversations, most active day, peak hour, time the app was open, topic breakdown and AI-fluency observations. Built entirely from local data.
   */
  public report<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      range?: "1m" | "3m" | "6m" | "12m"
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "range" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ReflectReportResponses, unknown, ThrowOnError>({
      url: "/reflect",
      ...options,
      ...params,
    })
  }
}

export class Pty extends HeyApiClient {
  /**
   * List available shells
   *
   * Get a list of available shells on the system.
   */
  public shells<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PtyShellsResponses, unknown, ThrowOnError>({
      url: "/pty/shells",
      ...options,
      ...params,
    })
  }

  /**
   * List PTY sessions
   *
   * Get a list of all active pseudo-terminal (PTY) sessions managed by OpenAnalyst.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PtyListResponses, unknown, ThrowOnError>({
      url: "/pty",
      ...options,
      ...params,
    })
  }

  /**
   * Create PTY session
   *
   * Create a new pseudo-terminal (PTY) session for running shell commands and processes.
   */
  public create<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      command?: string
      args?: Array<string>
      cwd?: string
      title?: string
      env?: {
        [key: string]: string
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "command" },
            { in: "body", key: "args" },
            { in: "body", key: "cwd" },
            { in: "body", key: "title" },
            { in: "body", key: "env" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PtyCreateResponses, PtyCreateErrors, ThrowOnError>({
      url: "/pty",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Remove PTY session
   *
   * Remove and terminate a specific pseudo-terminal (PTY) session.
   */
  public remove<ThrowOnError extends boolean = false>(
    parameters: {
      ptyID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ptyID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<PtyRemoveResponses, PtyRemoveErrors, ThrowOnError>({
      url: "/pty/{ptyID}",
      ...options,
      ...params,
    })
  }

  /**
   * Get PTY session
   *
   * Retrieve detailed information about a specific pseudo-terminal (PTY) session.
   */
  public get<ThrowOnError extends boolean = false>(
    parameters: {
      ptyID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ptyID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PtyGetResponses, PtyGetErrors, ThrowOnError>({
      url: "/pty/{ptyID}",
      ...options,
      ...params,
    })
  }

  /**
   * Update PTY session
   *
   * Update properties of an existing pseudo-terminal (PTY) session.
   */
  public update<ThrowOnError extends boolean = false>(
    parameters: {
      ptyID: string
      directory?: string
      workspace?: string
      title?: string
      size?: {
        rows: number
        cols: number
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ptyID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "title" },
            { in: "body", key: "size" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).put<PtyUpdateResponses, PtyUpdateErrors, ThrowOnError>({
      url: "/pty/{ptyID}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Connect to PTY session
   *
   * Establish a WebSocket connection to interact with a pseudo-terminal (PTY) session in real-time.
   */
  public connect<ThrowOnError extends boolean = false>(
    parameters: {
      ptyID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ptyID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PtyConnectResponses, PtyConnectErrors, ThrowOnError>({
      url: "/pty/{ptyID}/connect",
      ...options,
      ...params,
    })
  }
}

export class Config2 extends HeyApiClient {
  /**
   * Get configuration
   *
   * Retrieve the current OpenAnalyst configuration settings and preferences.
   */
  public get<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ConfigGetResponses, unknown, ThrowOnError>({
      url: "/config",
      ...options,
      ...params,
    })
  }

  /**
   * Update configuration
   *
   * Update OpenAnalyst configuration settings and preferences.
   */
  public update<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      config?: Config3
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "config", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).patch<ConfigUpdateResponses, ConfigUpdateErrors, ThrowOnError>({
      url: "/config",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * List config providers
   *
   * Get a list of all configured AI providers and their default models.
   */
  public providers<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ConfigProvidersResponses, unknown, ThrowOnError>({
      url: "/config/providers",
      ...options,
      ...params,
    })
  }
}

export class Tool extends HeyApiClient {
  /**
   * List tool IDs
   *
   * Get a list of all available tool IDs, including both built-in tools and dynamically registered tools.
   */
  public ids<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ToolIdsResponses, ToolIdsErrors, ThrowOnError>({
      url: "/experimental/tool/ids",
      ...options,
      ...params,
    })
  }

  /**
   * List tools
   *
   * Get a list of available tools with their JSON schema parameters for a specific provider and model combination.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      provider: string
      model: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "provider" },
            { in: "query", key: "model" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ToolListResponses, ToolListErrors, ThrowOnError>({
      url: "/experimental/tool",
      ...options,
      ...params,
    })
  }
}

export class Worktree extends HeyApiClient {
  /**
   * Remove worktree
   *
   * Remove a git worktree and delete its branch.
   */
  public remove<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      worktreeRemoveInput?: WorktreeRemoveInput
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "worktreeRemoveInput", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<WorktreeRemoveResponses, WorktreeRemoveErrors, ThrowOnError>({
      url: "/experimental/worktree",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * List worktrees
   *
   * List all sandbox worktrees for the current project.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<WorktreeListResponses, unknown, ThrowOnError>({
      url: "/experimental/worktree",
      ...options,
      ...params,
    })
  }

  /**
   * Create worktree
   *
   * Create a new git worktree for the current project and run any configured startup scripts.
   */
  public create<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      worktreeCreateInput?: WorktreeCreateInput
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "worktreeCreateInput", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<WorktreeCreateResponses, WorktreeCreateErrors, ThrowOnError>({
      url: "/experimental/worktree",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Reset worktree
   *
   * Reset a worktree branch to the primary default branch.
   */
  public reset<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      worktreeResetInput?: WorktreeResetInput
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "worktreeResetInput", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<WorktreeResetResponses, WorktreeResetErrors, ThrowOnError>({
      url: "/experimental/worktree/reset",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Session2 extends HeyApiClient {
  /**
   * List sessions
   *
   * Get a list of all OpenAnalyst sessions, sorted by most recently updated.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      scope?: "project"
      path?: string
      roots?: boolean | "true" | "false"
      start?: number
      search?: string
      limit?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "scope" },
            { in: "query", key: "path" },
            { in: "query", key: "roots" },
            { in: "query", key: "start" },
            { in: "query", key: "search" },
            { in: "query", key: "limit" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionListResponses, unknown, ThrowOnError>({
      url: "/session",
      ...options,
      ...params,
    })
  }

  /**
   * Create session
   *
   * Create a new OpenAnalyst session for interacting with AI assistants and managing conversations.
   */
  public create<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      parentID?: string
      title?: string
      metadata?: {
        [key: string]: unknown
      }
      permission?: PermissionRuleset
      workspaceID?: string
      agent?: string
      model?: {
        providerID: string
        id: string
        variant?: string
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "parentID" },
            { in: "body", key: "title" },
            { in: "body", key: "metadata" },
            { in: "body", key: "permission" },
            { in: "body", key: "workspaceID" },
            { in: "body", key: "agent" },
            { in: "body", key: "model" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionCreateResponses, SessionCreateErrors, ThrowOnError>({
      url: "/session",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get session status
   *
   * Retrieve the current status of all sessions, including active, idle, and completed states.
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionStatusResponses, SessionStatusErrors, ThrowOnError>({
      url: "/session/status",
      ...options,
      ...params,
    })
  }

  /**
   * Get session goal status
   *
   * Retrieve goal auto-continue policy, persisted state, and runtime counters for a session.
   */
  public goalStatus<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionGoalStatusResponses, SessionGoalStatusErrors, ThrowOnError>({
      url: "/session/{sessionID}/goal",
      ...options,
      ...params,
    })
  }

  /**
   * Delete session
   *
   * Delete a session and permanently remove all associated data, including messages and history.
   */
  public delete<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<SessionDeleteResponses, SessionDeleteErrors, ThrowOnError>({
      url: "/session/{sessionID}",
      ...options,
      ...params,
    })
  }

  /**
   * Get session
   *
   * Retrieve detailed information about a specific OpenAnalyst session.
   */
  public get<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionGetResponses, SessionGetErrors, ThrowOnError>({
      url: "/session/{sessionID}",
      ...options,
      ...params,
    })
  }

  /**
   * Update session
   *
   * Update properties of an existing session, such as title or other metadata.
   */
  public update<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      title?: string
      permission?: PermissionRuleset
      goal?: {
        text?: string
        action?: "start" | "pause" | "resume" | "clear"
        policy?: {
          maxTurns?: number
          maxDurationMs?: number
          maxTokens?: number
          minDelayMs?: number
          noProgressTokenThreshold?: number
          noProgressTurnsBeforePause?: number
          budgetWrapupRatio?: number
          maxPromptFailures?: number
          allowedAgents?: Array<string>
          allowedSkills?: Array<string>
        }
      } | null
      time?: {
        archived?: number | null
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "title" },
            { in: "body", key: "permission" },
            { in: "body", key: "goal" },
            { in: "body", key: "time" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).patch<SessionUpdateResponses, SessionUpdateErrors, ThrowOnError>({
      url: "/session/{sessionID}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get session children
   *
   * Retrieve all child sessions that were forked from the specified parent session.
   */
  public children<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionChildrenResponses, SessionChildrenErrors, ThrowOnError>({
      url: "/session/{sessionID}/children",
      ...options,
      ...params,
    })
  }

  /**
   * Get session todos
   *
   * Retrieve the todo list associated with a specific session, showing tasks and action items.
   */
  public todo<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionTodoResponses, SessionTodoErrors, ThrowOnError>({
      url: "/session/{sessionID}/todo",
      ...options,
      ...params,
    })
  }

  /**
   * Initialize session
   *
   * Analyze the current application and create an AGENTS.md file with project-specific agent configurations.
   */
  public init<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      modelID?: string
      providerID?: string
      messageID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "modelID" },
            { in: "body", key: "providerID" },
            { in: "body", key: "messageID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionInitResponses, SessionInitErrors, ThrowOnError>({
      url: "/session/{sessionID}/init",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Fork session
   *
   * Create a new session by forking an existing session at a specific message point.
   */
  public fork<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      messageID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "messageID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionForkResponses, unknown, ThrowOnError>({
      url: "/session/{sessionID}/fork",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Abort session
   *
   * Abort an active session and stop any ongoing AI processing or command execution.
   */
  public abort<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionAbortResponses, SessionAbortErrors, ThrowOnError>({
      url: "/session/{sessionID}/abort",
      ...options,
      ...params,
    })
  }

  /**
   * Unshare session
   *
   * Remove the shareable link for a session, making it private again.
   */
  public unshare<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<SessionUnshareResponses, SessionUnshareErrors, ThrowOnError>({
      url: "/session/{sessionID}/share",
      ...options,
      ...params,
    })
  }

  /**
   * Share session
   *
   * Create a shareable link for a session, allowing others to view the conversation.
   */
  public share<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionShareResponses, SessionShareErrors, ThrowOnError>({
      url: "/session/{sessionID}/share",
      ...options,
      ...params,
    })
  }

  /**
   * Get message diff
   *
   * Get the file changes (diff) that resulted from a specific user message in the session.
   */
  public diff<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      messageID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "messageID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionDiffResponses, unknown, ThrowOnError>({
      url: "/session/{sessionID}/diff",
      ...options,
      ...params,
    })
  }

  /**
   * Summarize session
   *
   * Generate a concise summary of the session using AI compaction to preserve key information.
   */
  public summarize<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      providerID?: string
      modelID?: string
      auto?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "providerID" },
            { in: "body", key: "modelID" },
            { in: "body", key: "auto" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionSummarizeResponses, SessionSummarizeErrors, ThrowOnError>({
      url: "/session/{sessionID}/summarize",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get session messages
   *
   * Retrieve all messages in a session, including user prompts and AI responses.
   */
  public messages<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      limit?: number
      before?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "limit" },
            { in: "query", key: "before" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionMessagesResponses, SessionMessagesErrors, ThrowOnError>({
      url: "/session/{sessionID}/message",
      ...options,
      ...params,
    })
  }

  /**
   * Send message
   *
   * Create and send a new message to a session, streaming the AI response.
   */
  public prompt<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      messageID?: string
      model?: {
        providerID: string
        modelID: string
      }
      agent?: string
      noReply?: boolean
      background?: boolean
      interrupt?: boolean
      tools?: {
        [key: string]: boolean
      }
      format?: OutputFormat
      system?: string
      variant?: string
      parts?: Array<
        TextPartInput | FilePartInput | AgentPartInput | SkillPartInput | PluginPartInput | SubtaskPartInput
      >
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "messageID" },
            { in: "body", key: "model" },
            { in: "body", key: "agent" },
            { in: "body", key: "noReply" },
            { in: "body", key: "background" },
            { in: "body", key: "interrupt" },
            { in: "body", key: "tools" },
            { in: "body", key: "format" },
            { in: "body", key: "system" },
            { in: "body", key: "variant" },
            { in: "body", key: "parts" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionPromptResponses, SessionPromptErrors, ThrowOnError>({
      url: "/session/{sessionID}/message",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Delete message
   *
   * Permanently delete a specific message (and all of its parts) from a session. This does not revert any file changes that may have been made while processing the message.
   */
  public deleteMessage<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      messageID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "path", key: "messageID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<
      SessionDeleteMessageResponses,
      SessionDeleteMessageErrors,
      ThrowOnError
    >({
      url: "/session/{sessionID}/message/{messageID}",
      ...options,
      ...params,
    })
  }

  /**
   * Get message
   *
   * Retrieve a specific message from a session by its message ID.
   */
  public message<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      messageID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "path", key: "messageID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<SessionMessageResponses, SessionMessageErrors, ThrowOnError>({
      url: "/session/{sessionID}/message/{messageID}",
      ...options,
      ...params,
    })
  }

  /**
   * Send async message
   *
   * Create and send a new message to a session asynchronously, starting the session if needed and returning immediately.
   */
  public promptAsync<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      messageID?: string
      model?: {
        providerID: string
        modelID: string
      }
      agent?: string
      noReply?: boolean
      background?: boolean
      interrupt?: boolean
      tools?: {
        [key: string]: boolean
      }
      format?: OutputFormat
      system?: string
      variant?: string
      parts?: Array<
        TextPartInput | FilePartInput | AgentPartInput | SkillPartInput | PluginPartInput | SubtaskPartInput
      >
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "messageID" },
            { in: "body", key: "model" },
            { in: "body", key: "agent" },
            { in: "body", key: "noReply" },
            { in: "body", key: "background" },
            { in: "body", key: "interrupt" },
            { in: "body", key: "tools" },
            { in: "body", key: "format" },
            { in: "body", key: "system" },
            { in: "body", key: "variant" },
            { in: "body", key: "parts" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionPromptAsyncResponses, SessionPromptAsyncErrors, ThrowOnError>({
      url: "/session/{sessionID}/prompt_async",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Send command
   *
   * Send a new command to a session for execution by the AI assistant.
   */
  public command<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      messageID?: string
      agent?: string
      model?: string
      arguments?: string
      command?: string
      variant?: string
      parts?: Array<TextPartInput | FilePartInput | AgentPartInput | SkillPartInput | PluginPartInput>
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "messageID" },
            { in: "body", key: "agent" },
            { in: "body", key: "model" },
            { in: "body", key: "arguments" },
            { in: "body", key: "command" },
            { in: "body", key: "variant" },
            { in: "body", key: "parts" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionCommandResponses, SessionCommandErrors, ThrowOnError>({
      url: "/session/{sessionID}/command",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Run shell command
   *
   * Execute a shell command within the session context and return the AI's response.
   */
  public shell<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      messageID?: string
      agent?: string
      model?: {
        providerID: string
        modelID: string
      }
      command?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "messageID" },
            { in: "body", key: "agent" },
            { in: "body", key: "model" },
            { in: "body", key: "command" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionShellResponses, SessionShellErrors, ThrowOnError>({
      url: "/session/{sessionID}/shell",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Revert message
   *
   * Revert a specific message in a session, undoing its effects and restoring the previous state.
   */
  public revert<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
      messageID?: string
      partID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "messageID" },
            { in: "body", key: "partID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionRevertResponses, SessionRevertErrors, ThrowOnError>({
      url: "/session/{sessionID}/revert",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Restore reverted messages
   *
   * Restore all previously reverted messages in a session.
   */
  public unrevert<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SessionUnrevertResponses, SessionUnrevertErrors, ThrowOnError>({
      url: "/session/{sessionID}/unrevert",
      ...options,
      ...params,
    })
  }
}

export class Part extends HeyApiClient {
  /**
   * Delete a part from a message
   */
  public delete<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      messageID: string
      partID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "path", key: "messageID" },
            { in: "path", key: "partID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<PartDeleteResponses, PartDeleteErrors, ThrowOnError>({
      url: "/session/{sessionID}/message/{messageID}/part/{partID}",
      ...options,
      ...params,
    })
  }

  /**
   * Update a part in a message
   */
  public update<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      messageID: string
      partID: string
      directory?: string
      workspace?: string
      part?: Part2
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "path", key: "messageID" },
            { in: "path", key: "partID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "part", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).patch<PartUpdateResponses, PartUpdateErrors, ThrowOnError>({
      url: "/session/{sessionID}/message/{messageID}/part/{partID}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Permission extends HeyApiClient {
  /**
   * Respond to permission
   *
   * Approve or deny a permission request from the AI assistant.
   *
   * @deprecated
   */
  public respond<ThrowOnError extends boolean = false>(
    parameters: {
      sessionID: string
      permissionID: string
      directory?: string
      workspace?: string
      response?: "once" | "always" | "reject"
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "sessionID" },
            { in: "path", key: "permissionID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "response" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PermissionRespondResponses, PermissionRespondErrors, ThrowOnError>({
      url: "/session/{sessionID}/permissions/{permissionID}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Respond to permission request
   *
   * Approve or deny a permission request from the AI assistant.
   */
  public reply<ThrowOnError extends boolean = false>(
    parameters: {
      requestID: string
      directory?: string
      workspace?: string
      reply?: "once" | "always" | "reject"
      message?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "requestID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "reply" },
            { in: "body", key: "message" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PermissionReplyResponses, PermissionReplyErrors, ThrowOnError>({
      url: "/permission/{requestID}/reply",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * List pending permissions
   *
   * Get all pending permission requests across all sessions.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PermissionListResponses, unknown, ThrowOnError>({
      url: "/permission",
      ...options,
      ...params,
    })
  }
}

export class Question extends HeyApiClient {
  /**
   * List pending questions
   *
   * Get all pending question requests across all sessions.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<QuestionListResponses, unknown, ThrowOnError>({
      url: "/question",
      ...options,
      ...params,
    })
  }

  /**
   * Reply to question request
   *
   * Provide answers to a question request from the AI assistant.
   */
  public reply<ThrowOnError extends boolean = false>(
    parameters: {
      requestID: string
      directory?: string
      workspace?: string
      answers?: Array<QuestionAnswer>
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "requestID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "answers" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<QuestionReplyResponses, QuestionReplyErrors, ThrowOnError>({
      url: "/question/{requestID}/reply",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Reject question request
   *
   * Reject a question request from the AI assistant.
   */
  public reject<ThrowOnError extends boolean = false>(
    parameters: {
      requestID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "requestID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<QuestionRejectResponses, QuestionRejectErrors, ThrowOnError>({
      url: "/question/{requestID}/reject",
      ...options,
      ...params,
    })
  }
}

export class Oauth extends HeyApiClient {
  /**
   * OAuth authorize
   *
   * Initiate OAuth authorization for a specific AI provider to get an authorization URL.
   */
  public authorize<ThrowOnError extends boolean = false>(
    parameters: {
      providerID: string
      directory?: string
      workspace?: string
      method?: number
      inputs?: {
        [key: string]: string
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "providerID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "method" },
            { in: "body", key: "inputs" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      ProviderOauthAuthorizeResponses,
      ProviderOauthAuthorizeErrors,
      ThrowOnError
    >({
      url: "/provider/{providerID}/oauth/authorize",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * OAuth callback
   *
   * Handle the OAuth callback from a provider after user authorization.
   */
  public callback<ThrowOnError extends boolean = false>(
    parameters: {
      providerID: string
      directory?: string
      workspace?: string
      method?: number
      code?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "providerID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "method" },
            { in: "body", key: "code" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      ProviderOauthCallbackResponses,
      ProviderOauthCallbackErrors,
      ThrowOnError
    >({
      url: "/provider/{providerID}/oauth/callback",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Provider extends HeyApiClient {
  /**
   * List providers
   *
   * Get a list of all available AI providers, including both available and connected ones.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ProviderListResponses, unknown, ThrowOnError>({
      url: "/provider",
      ...options,
      ...params,
    })
  }

  /**
   * Get provider auth methods
   *
   * Retrieve available authentication methods for all AI providers.
   */
  public auth<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<ProviderAuthResponses, unknown, ThrowOnError>({
      url: "/provider/auth",
      ...options,
      ...params,
    })
  }

  private _oauth?: Oauth
  get oauth(): Oauth {
    return (this._oauth ??= new Oauth({ client: this.client }))
  }
}

export class Transcription extends HeyApiClient {
  /**
   * Transcribe audio
   *
   * Transcribe transient composer audio using the configured transcription model.
   */
  public transcribe<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      transcriptionRequest?: TranscriptionRequest
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "transcriptionRequest", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      TranscriptionTranscribeResponses,
      TranscriptionTranscribeErrors,
      ThrowOnError
    >({
      url: "/transcription",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class History extends HeyApiClient {
  /**
   * List sync events
   *
   * List sync events for all aggregates. Keys are aggregate IDs the client already knows about, values are the last known sequence ID. Events with seq > value are returned for those aggregates. Aggregates not listed in the input get their full history.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      body?: {
        [key: string]: number
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "body", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SyncHistoryListResponses, SyncHistoryListErrors, ThrowOnError>({
      url: "/sync/history",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Sync extends HeyApiClient {
  /**
   * Start workspace sync
   *
   * Start sync loops for workspaces in the current project that have active sessions.
   */
  public start<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SyncStartResponses, unknown, ThrowOnError>({
      url: "/sync/start",
      ...options,
      ...params,
    })
  }

  /**
   * Replay sync events
   *
   * Validate and replay a complete sync event history.
   */
  public replay<ThrowOnError extends boolean = false>(
    parameters?: {
      query_directory?: string
      workspace?: string
      body_directory?: string
      events?: Array<{
        id: string
        aggregateID: string
        seq: number
        type: string
        data: {
          [key: string]: unknown
        }
      }>
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            {
              in: "query",
              key: "query_directory",
              map: "directory",
            },
            { in: "query", key: "workspace" },
            {
              in: "body",
              key: "body_directory",
              map: "directory",
            },
            { in: "body", key: "events" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<SyncReplayResponses, SyncReplayErrors, ThrowOnError>({
      url: "/sync/replay",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  private _history?: History
  get history(): History {
    return (this._history ??= new History({ client: this.client }))
  }
}

export class Auth2 extends HeyApiClient {
  /**
   * Clear onboarding auth token
   *
   * Remove any cached onboarding JWT from the sidecar's in-memory store.
   */
  public clearToken<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<OnboardingAuthClearTokenResponses, unknown, ThrowOnError>({
      url: "/onboarding/auth/token",
      ...options,
      ...params,
    })
  }

  /**
   * Set onboarding auth token
   *
   * Stash the user's OA Cognito JWT in the sidecar's in-memory onboarding auth store. The onboarding agent's handle tools read this to call the OA backend on the user's behalf. No persistence — token clears on sidecar restart.
   */
  public setToken<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      jwt?: string
      providerJwt?: string
      apiBaseUrl?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "jwt" },
            { in: "body", key: "providerJwt" },
            { in: "body", key: "apiBaseUrl" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<OnboardingAuthSetTokenResponses, unknown, ThrowOnError>({
      url: "/onboarding/auth/token",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Onboarding extends HeyApiClient {
  private _auth?: Auth2
  get auth(): Auth2 {
    return (this._auth ??= new Auth2({ client: this.client }))
  }
}

export class Find extends HeyApiClient {
  /**
   * Find text
   *
   * Search for text patterns across files in the project using ripgrep.
   */
  public text<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      pattern: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "pattern" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<FindTextResponses, unknown, ThrowOnError>({
      url: "/find",
      ...options,
      ...params,
    })
  }

  /**
   * Find files
   *
   * Search for files or directories by name or pattern in the project directory.
   */
  public files<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      query: string
      dirs?: "true" | "false"
      type?: "file" | "directory"
      limit?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "query" },
            { in: "query", key: "dirs" },
            { in: "query", key: "type" },
            { in: "query", key: "limit" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<FindFilesResponses, unknown, ThrowOnError>({
      url: "/find/file",
      ...options,
      ...params,
    })
  }

  /**
   * Find symbols
   *
   * Search for workspace symbols like functions, classes, and variables using LSP.
   */
  public symbols<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      query: string
      file?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "query" },
            { in: "query", key: "file" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<FindSymbolsResponses, unknown, ThrowOnError>({
      url: "/find/symbol",
      ...options,
      ...params,
    })
  }
}

export class File extends HeyApiClient {
  /**
   * List files
   *
   * List files and directories in a specified path.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      path: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "path" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<FileListResponses, unknown, ThrowOnError>({
      url: "/file",
      ...options,
      ...params,
    })
  }

  /**
   * Read file
   *
   * Read the content of a specified file.
   */
  public read<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      path: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "path" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<FileReadResponses, unknown, ThrowOnError>({
      url: "/file/content",
      ...options,
      ...params,
    })
  }

  /**
   * Get file status
   *
   * Get the git status of all files in the project.
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<FileStatusResponses, unknown, ThrowOnError>({
      url: "/file/status",
      ...options,
      ...params,
    })
  }

  /**
   * Write file
   *
   * Write content to a file at the specified path relative to the project directory.
   */
  public write<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      path?: string
      content?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "path" },
            { in: "body", key: "content" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<FileWriteResponses, unknown, ThrowOnError>({
      url: "/file/write",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Event extends HeyApiClient {
  /**
   * Subscribe to events
   *
   * Get events
   */
  public subscribe<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).sse.get<EventSubscribeResponses, unknown, ThrowOnError>({
      url: "/event",
      ...options,
      ...params,
    })
  }
}

export class Auth3 extends HeyApiClient {
  /**
   * Remove MCP OAuth
   *
   * Remove OAuth credentials for an MCP server
   */
  public remove<ThrowOnError extends boolean = false>(
    parameters: {
      name: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "name" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<McpAuthRemoveResponses, McpAuthRemoveErrors, ThrowOnError>({
      url: "/mcp/{name}/auth",
      ...options,
      ...params,
    })
  }

  /**
   * Start MCP OAuth
   *
   * Start OAuth authentication flow for a Model Context Protocol (MCP) server.
   */
  public start<ThrowOnError extends boolean = false>(
    parameters: {
      name: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "name" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<McpAuthStartResponses, McpAuthStartErrors, ThrowOnError>({
      url: "/mcp/{name}/auth",
      ...options,
      ...params,
    })
  }

  /**
   * Complete MCP OAuth
   *
   * Complete OAuth authentication for a Model Context Protocol (MCP) server using the authorization code.
   */
  public callback<ThrowOnError extends boolean = false>(
    parameters: {
      name: string
      directory?: string
      workspace?: string
      code?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "name" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "code" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<McpAuthCallbackResponses, McpAuthCallbackErrors, ThrowOnError>({
      url: "/mcp/{name}/auth/callback",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Authenticate MCP OAuth
   *
   * Start OAuth flow and wait for callback (opens browser)
   */
  public authenticate<ThrowOnError extends boolean = false>(
    parameters: {
      name: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "name" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<McpAuthAuthenticateResponses, McpAuthAuthenticateErrors, ThrowOnError>(
      {
        url: "/mcp/{name}/auth/authenticate",
        ...options,
        ...params,
      },
    )
  }
}

export class Mcp2 extends HeyApiClient {
  /**
   * Get MCP status
   *
   * Get the status of all Model Context Protocol (MCP) servers.
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<McpStatusResponses, unknown, ThrowOnError>({
      url: "/mcp",
      ...options,
      ...params,
    })
  }

  /**
   * Add MCP server
   *
   * Dynamically add a new Model Context Protocol (MCP) server to the system.
   */
  public add<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      name?: string
      config?: McpLocalConfig | McpRemoteConfig
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "name" },
            { in: "body", key: "config" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<McpAddResponses, McpAddErrors, ThrowOnError>({
      url: "/mcp",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Connect an MCP server
   */
  public connect<ThrowOnError extends boolean = false>(
    parameters: {
      name: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "name" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<McpConnectResponses, unknown, ThrowOnError>({
      url: "/mcp/{name}/connect",
      ...options,
      ...params,
    })
  }

  /**
   * Disconnect an MCP server
   */
  public disconnect<ThrowOnError extends boolean = false>(
    parameters: {
      name: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "name" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<McpDisconnectResponses, unknown, ThrowOnError>({
      url: "/mcp/{name}/disconnect",
      ...options,
      ...params,
    })
  }

  private _auth?: Auth3
  get auth(): Auth3 {
    return (this._auth ??= new Auth3({ client: this.client }))
  }
}

export class Control extends HeyApiClient {
  /**
   * Get next TUI request
   *
   * Retrieve the next TUI (Terminal User Interface) request from the queue for processing.
   */
  public next<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<TuiControlNextResponses, unknown, ThrowOnError>({
      url: "/tui/control/next",
      ...options,
      ...params,
    })
  }

  /**
   * Submit TUI response
   *
   * Submit a response to the TUI request queue to complete a pending request.
   */
  public response<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      body?: unknown
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "body", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiControlResponseResponses, unknown, ThrowOnError>({
      url: "/tui/control/response",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Tui extends HeyApiClient {
  /**
   * Append TUI prompt
   *
   * Append prompt to the TUI
   */
  public appendPrompt<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      text?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "text" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiAppendPromptResponses, TuiAppendPromptErrors, ThrowOnError>({
      url: "/tui/append-prompt",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Open help dialog
   *
   * Open the help dialog in the TUI to display user assistance information.
   */
  public openHelp<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiOpenHelpResponses, unknown, ThrowOnError>({
      url: "/tui/open-help",
      ...options,
      ...params,
    })
  }

  /**
   * Open sessions dialog
   *
   * Open the session dialog
   */
  public openSessions<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiOpenSessionsResponses, unknown, ThrowOnError>({
      url: "/tui/open-sessions",
      ...options,
      ...params,
    })
  }

  /**
   * Open themes dialog
   *
   * Open the theme dialog
   */
  public openThemes<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiOpenThemesResponses, unknown, ThrowOnError>({
      url: "/tui/open-themes",
      ...options,
      ...params,
    })
  }

  /**
   * Open models dialog
   *
   * Open the model dialog
   */
  public openModels<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiOpenModelsResponses, unknown, ThrowOnError>({
      url: "/tui/open-models",
      ...options,
      ...params,
    })
  }

  /**
   * Submit TUI prompt
   *
   * Submit the prompt
   */
  public submitPrompt<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiSubmitPromptResponses, unknown, ThrowOnError>({
      url: "/tui/submit-prompt",
      ...options,
      ...params,
    })
  }

  /**
   * Clear TUI prompt
   *
   * Clear the prompt
   */
  public clearPrompt<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiClearPromptResponses, unknown, ThrowOnError>({
      url: "/tui/clear-prompt",
      ...options,
      ...params,
    })
  }

  /**
   * Execute TUI command
   *
   * Execute a TUI command (e.g. agent_cycle)
   */
  public executeCommand<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      command?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "command" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiExecuteCommandResponses, TuiExecuteCommandErrors, ThrowOnError>({
      url: "/tui/execute-command",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Show TUI toast
   *
   * Show a toast notification in the TUI
   */
  public showToast<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      title?: string
      message?: string
      variant?: "info" | "success" | "warning" | "error"
      duration?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "title" },
            { in: "body", key: "message" },
            { in: "body", key: "variant" },
            { in: "body", key: "duration" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiShowToastResponses, unknown, ThrowOnError>({
      url: "/tui/show-toast",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Publish TUI event
   *
   * Publish a TUI event
   */
  public publish<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      body?: EventTuiPromptAppend | EventTuiCommandExecute | EventTuiToastShow | EventTuiSessionSelect
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "body", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiPublishResponses, TuiPublishErrors, ThrowOnError>({
      url: "/tui/publish",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Select session
   *
   * Navigate the TUI to display the specified session.
   */
  public selectSession<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      sessionID?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "sessionID" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<TuiSelectSessionResponses, TuiSelectSessionErrors, ThrowOnError>({
      url: "/tui/select-session",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  private _control?: Control
  get control(): Control {
    return (this._control ??= new Control({ client: this.client }))
  }
}

export class Plugin extends HeyApiClient {
  /**
   * List installed plugins
   *
   * Return local, global, built-in, and directory-discovered plugins for the active workspace.
   */
  public installed<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginInstalledResponses, PluginInstalledErrors, ThrowOnError>({
      url: "/plugin/installed",
      ...options,
      ...params,
    })
  }

  /**
   * Install a plugin
   *
   * Install or configure a plugin spec in the active workspace or global OpenAnalyst config.
   */
  public install<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      spec?: string
      hostedPluginId?: string
      handle?: string
      scope?: "project" | "global"
      force?: boolean
      approved?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "spec" },
            { in: "body", key: "hostedPluginId" },
            { in: "body", key: "handle" },
            { in: "body", key: "scope" },
            { in: "body", key: "force" },
            { in: "body", key: "approved" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginInstallResponses, PluginInstallErrors, ThrowOnError>({
      url: "/plugin/installed",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Remove a plugin
   *
   * Remove a config-backed plugin from the active workspace or global OpenAnalyst config.
   */
  public remove<ThrowOnError extends boolean = false>(
    parameters: {
      name: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "name" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<PluginRemoveResponses, PluginRemoveErrors, ThrowOnError>({
      url: "/plugin/installed/{name}",
      ...options,
      ...params,
    })
  }

  /**
   * Soft-reload the plugin runtime
   *
   * Re-read installed plugins, bundled defaults, settings, and hooks in-process — no engine relaunch. Returns what was reloaded and anything that still needs a full restart.
   */
  public reload<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginReloadResponses, unknown, ThrowOnError>({
      url: "/plugin/reload",
      ...options,
      ...params,
    })
  }

  /**
   * List file-defined plugin catalog
   *
   * Default file-defined plugins with installed/available state for the active project.
   */
  public fileCatalog<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginFileCatalogResponses, unknown, ThrowOnError>({
      url: "/plugin/file-catalog",
      ...options,
      ...params,
    })
  }

  /**
   * Install a file-defined default plugin
   *
   * Copy the default plugin's folder into the project's .openanalyst/plugins/.
   */
  public fileInstall<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginFileInstallResponses, unknown, ThrowOnError>({
      url: "/plugin/file-catalog/{id}/install",
      ...options,
      ...params,
    })
  }

  /**
   * Read a file-defined plugin asset
   *
   * Return a safe plugin-local asset such as assets/banner-1.png.
   */
  public fileAsset<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
      path: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "path" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginFileAssetResponses, PluginFileAssetErrors, ThrowOnError>({
      url: "/plugin/file-catalog/{id}/asset",
      ...options,
      ...params,
    })
  }

  /**
   * Export a file-defined plugin
   *
   * Download the active project-local plugin folder as a zip archive.
   */
  public fileExport<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginFileExportResponses, PluginFileExportErrors, ThrowOnError>({
      url: "/plugin/file-catalog/{id}/export",
      ...options,
      ...params,
    })
  }

  /**
   * Serve a system plugin's bundled UI app
   *
   * Static files of the plugin's built iframe app (packages/plugin-apps/<dir>/dist). Path-based so relative assets resolve. Defaults to index.html.
   */
  public appFile<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginAppFileResponses, PluginAppFileErrors, ThrowOnError>({
      url: "/plugin/app/{id}/*",
      ...options,
      ...params,
    })
  }

  /**
   * Install the OA-App Builder kit into the active project
   *
   * Extracts the custom-app template kit into <project>/.openanalyst/oa-app-builder/ and surfaces its skill + agent so OpenAnalyst can scaffold project-scoped custom apps.
   */
  public installOaAppBuilder<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginInstallOaAppBuilderResponses, unknown, ThrowOnError>({
      url: "/plugin/oa-app-builder/install",
      ...options,
      ...params,
    })
  }

  /**
   * Read a file-defined plugin's capabilities
   *
   * Tools, skills, and agents (all .md) parsed from the plugin folder — the file-driven source for a plugin-app's surfaces.
   */
  public capabilities<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginCapabilitiesResponses, PluginCapabilitiesErrors, ThrowOnError>({
      url: "/plugin/file-catalog/{id}/capabilities",
      ...options,
      ...params,
    })
  }

  /**
   * List a file-defined plugin folder's files
   *
   * List files (e.g. canvas .html artifacts) in a plugin folder subdirectory, newest first.
   */
  public fileList<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
      dir?: string
      ext?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "dir" },
            { in: "query", key: "ext" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginFileListResponses, PluginFileListErrors, ThrowOnError>({
      url: "/plugin/file-catalog/{id}/files",
      ...options,
      ...params,
    })
  }

  /**
   * Read a file-defined plugin folder text file
   *
   * Return the UTF-8 text of a plugin-local file (e.g. a canvas HTML artifact).
   */
  public fileRead<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
      path: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "path" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginFileReadResponses, PluginFileReadErrors, ThrowOnError>({
      url: "/plugin/file-catalog/{id}/file",
      ...options,
      ...params,
    })
  }

  /**
   * Write a file-defined plugin folder text file
   *
   * Save UTF-8 text to a plugin-local file (creates parent dirs). Used by a plugin-app's canvas to save artifacts/edits.
   */
  public fileWrite<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
      path?: string
      content?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "path" },
            { in: "body", key: "content" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).put<PluginFileWriteResponses, PluginFileWriteErrors, ThrowOnError>({
      url: "/plugin/file-catalog/{id}/file",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Uninstall a file-defined plugin
   *
   * Remove the plugin folder from the project. Defaults remain installable in the catalog. Pass ?keepData=1 to keep the app installed-but-removed while preserving the user's output (state/canvas/db) so a later reinstall restores their work.
   */
  public fileUninstall<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<PluginFileUninstallResponses, unknown, ThrowOnError>({
      url: "/plugin/file-catalog/{id}",
      ...options,
      ...params,
    })
  }

  /**
   * Enable or disable an installed file-defined plugin app
   *
   * Toggle whether an installed project plugin app is active for the current project without deleting its folder or user data.
   */
  public fileSetEnabled<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
      enabled?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "enabled" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      PluginFileSetEnabledResponses,
      PluginFileSetEnabledErrors,
      ThrowOnError
    >({
      url: "/plugin/file-catalog/{id}/enabled",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * List plugin catalog items
   *
   * Return local and hosted plugin catalog items for installable OpenAnalyst plugins.
   */
  public catalog<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      handle?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "handle" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginCatalogResponses, unknown, ThrowOnError>({
      url: "/plugin/catalog",
      ...options,
      ...params,
    })
  }

  /**
   * List enabled plugin apps
   *
   * Return declarative plugin app descriptors for the active workspace.
   */
  public apps<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginAppsResponses, unknown, ThrowOnError>({
      url: "/plugin/apps",
      ...options,
      ...params,
    })
  }

  /**
   * Discover plugin artifact actions
   *
   * Return declared plugin actions for the current file or selected-text artifact context.
   */
  public artifactActions<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      artifact?:
        | {
            type: "file"
            path: string
            mimeType?: string
            byteSize?: number
          }
        | {
            type: "selection"
            path: string
            text: string
            range?: {
              startLine: number
              endLine: number
            }
            mimeType?: string
          }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "artifact" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginArtifactActionsResponses, unknown, ThrowOnError>({
      url: "/plugin/artifact-actions",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get plugin page payload
   *
   * Execute the plugin view tool and return a validated declarative page manifest.
   */
  public page<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PluginPageResponses, PluginPageErrors, ThrowOnError>({
      url: "/plugin/apps/{id}/page",
      ...options,
      ...params,
    })
  }

  /**
   * Get plugin dashboard state
   *
   * Return project-scoped dashboard state for a plugin app.
   */
  public dashboardState<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      PluginDashboardStateResponses,
      PluginDashboardStateErrors,
      ThrowOnError
    >({
      url: "/plugin/apps/{id}/dashboard-state",
      ...options,
      ...params,
    })
  }

  /**
   * Update plugin dashboard state
   *
   * Persist project-scoped dashboard state for a plugin app.
   */
  public updateDashboardState<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
      layoutLocked?: boolean
      lockedAt?: string
      lockedReason?: string
      activeDefault?: "system" | "user" | "custom"
      overlay?: {
        version?: string
        title?: string
        description?: string
        blockOrder?: Array<string>
        hiddenBlockIds?: Array<string>
        blockOverrides?: {
          [key: string]: {
            [key: string]: unknown
          }
        }
        componentIndex?: {
          version?: string
          summary?: string
          references?: Array<{
            id: string
            label: string
            kind: "component" | "chart" | "analysis" | "folder" | "feature" | "action" | "dataset" | "report"
            description?: string
            path?: string
            importance?: "low" | "medium" | "high" | "critical"
            whenToUse?: string
            inputs?: Array<string>
            outputs?: Array<string>
            chartTypes?: Array<string>
          }>
        }
      }
      userDefault?: {
        id: string
        label: string
        scope: "system" | "user"
        description?: string
        overlay?: {
          version?: string
          title?: string
          description?: string
          blockOrder?: Array<string>
          hiddenBlockIds?: Array<string>
          blockOverrides?: {
            [key: string]: {
              [key: string]: unknown
            }
          }
          componentIndex?: {
            version?: string
            summary?: string
            references?: Array<{
              id: string
              label: string
              kind: "component" | "chart" | "analysis" | "folder" | "feature" | "action" | "dataset" | "report"
              description?: string
              path?: string
              importance?: "low" | "medium" | "high" | "critical"
              whenToUse?: string
              inputs?: Array<string>
              outputs?: Array<string>
              chartTypes?: Array<string>
            }>
          }
        }
        createdAt?: string
        updatedAt?: string
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "layoutLocked" },
            { in: "body", key: "lockedAt" },
            { in: "body", key: "lockedReason" },
            { in: "body", key: "activeDefault" },
            { in: "body", key: "overlay" },
            { in: "body", key: "userDefault" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).put<
      PluginUpdateDashboardStateResponses,
      PluginUpdateDashboardStateErrors,
      ThrowOnError
    >({
      url: "/plugin/apps/{id}/dashboard-state",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * List dynamic dashboard widgets
   *
   * Return the dynamic widgets a plugin has pushed for the current project + workspace.
   */
  public listDashboardWidgets<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      PluginListDashboardWidgetsResponses,
      PluginListDashboardWidgetsErrors,
      ThrowOnError
    >({
      url: "/plugin/apps/{id}/dashboard/widgets",
      ...options,
      ...params,
    })
  }

  /**
   * Upsert a dynamic dashboard widget
   *
   * Create or update a widget the host will merge with the plugin's static page view. Widgets persist across reloads per (plugin, project, workspace).
   */
  public upsertDashboardWidget<ThrowOnError extends boolean = false>(
    parameters: {
      path_id: string
      directory?: string
      workspace?: string
      body_id?: string
      block?:
        | {
            id: string
            type: "hero"
            eyebrow?: string
            title: string
            description?: string
            imageUrl?: string
          }
        | {
            id: string
            type: "markdown"
            content: string
          }
        | {
            id: string
            type: "stats"
            title?: string
            items: Array<{
              label: string
              value: string
              change?: string
              trend?: "up" | "down"
            }>
            actions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
          }
        | {
            id: string
            type: "calendar"
            title?: string
            visibleMonth: string
            items: Array<{
              id: string
              title: string
              startDate: string
              endDate: string
              status?: string
              channel?: string
              meta?: {
                [key: string]: unknown
              }
            }>
            statuses?: Array<{
              id: string
              label: string
              color?: string
              background?: string
            }>
            channels?: Array<{
              id: string
              label: string
              color?: string
            }>
            editForm?: {
              fields?: Array<{
                key: string
                label: string
                type: "text" | "textarea" | "select" | "toggle" | "number" | "password" | "date" | "month"
                required?: boolean
                placeholder?: string
                description?: string
                sensitive?: boolean
                min?: number
                max?: number
                step?: number
                options?: Array<{
                  label: string
                  value: string
                }>
                visibleWhen?: unknown
                disabledWhen?: unknown
              }>
              sections?: Array<{
                title?: string
                description?: string
                fields: Array<{
                  key: string
                  label: string
                  type: "text" | "textarea" | "select" | "toggle" | "number" | "password" | "date" | "month"
                  required?: boolean
                  placeholder?: string
                  description?: string
                  sensitive?: boolean
                  min?: number
                  max?: number
                  step?: number
                  options?: Array<{
                    label: string
                    value: string
                  }>
                  visibleWhen?: unknown
                  disabledWhen?: unknown
                }>
                visibleWhen?: unknown
              }>
              note?: string
              submitToolName: string
              submitLabel?: string
              submitAction?: {
                id: string
                label: string
                args?: {
                  [key: string]: unknown
                }
                variant?: "primary" | "secondary" | "ghost"
                risk?: "read" | "local_write" | "external_write" | "destructive"
                confirm?: {
                  title?: string
                  description?: string
                  sideEffect?: string
                  reversibility?: string
                  payloadSummary?: string
                }
                visibleWhen?: unknown
                disabledWhen?: unknown
                disabledReason?: string
                refreshWidgetIds?: Array<string>
                input?: {
                  [key: string]: {
                    source: "view" | "block" | "row" | "values" | "args"
                    path: string
                    fallback?: unknown
                  }
                }
              }
            }
            actions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
            source?: {
              [key: string]: unknown
            }
            diagnostics?: Array<{
              message: string
              tone?: "info" | "success" | "warning" | "error"
            }>
            emptyState?: {
              title?: string
              description?: string
            }
          }
        | {
            id: string
            type: "chart"
            title?: string
            chartType?: "line" | "bar" | "doughnut" | "pie" | "radar" | "polarArea"
            data: {
              labels: Array<string>
              series: Array<{
                key: string
                label: string
                data: Array<number>
                color?: string
              }>
            }
            options?: {
              [key: string]: unknown
            }
          }
        | {
            id: string
            type: "table"
            title?: string
            columns: Array<{
              key: string
              label: string
              sortable?: boolean
              width?: string
              align?: "left" | "center" | "right"
              format?: "text" | "status" | "code" | "date" | "datetime" | "currency" | "url" | "boolean" | "json"
            }>
            rows: Array<{
              [key: string]: unknown
            }>
            rowIdKey?: string
            rowActions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
            expandedRows?: {
              [key: string]: Array<unknown>
            }
            emptyState?: {
              title?: string
              description?: string
            }
          }
        | {
            id: string
            type: "list"
            title?: string
            items: Array<{
              id?: string
              title: string
              status: "success" | "info" | "warning" | "error"
              timestamp: string
              description?: string
              href?: string
            }>
            actions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
            itemActions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
            emptyState?: {
              title?: string
              description?: string
            }
          }
        | {
            id: string
            type: "detail"
            title?: string
            sections: Array<{
              title?: string
              items: Array<{
                label: string
                value: unknown
                hint?: string
              }>
            }>
            actions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
          }
        | {
            id: string
            type: "form"
            title?: string
            fields?: Array<{
              key: string
              label: string
              type: "text" | "textarea" | "select" | "toggle" | "number" | "password" | "date" | "month"
              required?: boolean
              placeholder?: string
              description?: string
              sensitive?: boolean
              min?: number
              max?: number
              step?: number
              options?: Array<{
                label: string
                value: string
              }>
              visibleWhen?: unknown
              disabledWhen?: unknown
            }>
            sections?: Array<{
              title?: string
              description?: string
              fields: Array<{
                key: string
                label: string
                type: "text" | "textarea" | "select" | "toggle" | "number" | "password" | "date" | "month"
                required?: boolean
                placeholder?: string
                description?: string
                sensitive?: boolean
                min?: number
                max?: number
                step?: number
                options?: Array<{
                  label: string
                  value: string
                }>
                visibleWhen?: unknown
                disabledWhen?: unknown
              }>
              visibleWhen?: unknown
            }>
            values?: {
              [key: string]: unknown
            }
            note?: string
            submitToolName: string
            submitLabel?: string
            submitAction?: {
              id: string
              label: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }
          }
        | {
            id: string
            type: "todo"
            title?: string
            items: Array<{
              id: string
              title: string
              status: "todo" | "doing" | "done" | "blocked"
              priority?: "low" | "medium" | "high"
              dueAt?: string
              source?: string
            }>
            submitToolName: string
          }
        | {
            id: string
            type: "card_grid"
            title?: string
            items: Array<{
              id: string
              title: string
              description?: string
              imageUrl?: string
              eyebrow?: string
              href?: string
            }>
            actions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
            itemActions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
            emptyState?: {
              title?: string
              description?: string
            }
          }
        | {
            id: string
            type: "gallery"
            title?: string
            items: Array<{
              src: string
              alt?: string
              title?: string
              description?: string
            }>
          }
        | {
            id: string
            type: "crm"
            title?: string
            currency?: string
            activeObject: string
            submitToolName: string
            objects: Array<{
              key: string
              label: string
              singular: string
              icon?: string
              fields: Array<{
                key: string
                label: string
                type: "text" | "textarea" | "select" | "currency" | "date" | "number" | "boolean" | "relation"
                required?: boolean
                object?: string
                options?: Array<{
                  label: string
                  value: string
                }>
                currencyCode?: string
              }>
            }>
            fields?: Array<{
              [key: string]: unknown
            }>
            views: Array<{
              id: string
              object: string
              label: string
              mode: "table" | "board" | "automation"
              filters?: string
              sort?: string
              group_by?: string | null
            }>
            rows: Array<{
              [key: string]: unknown
            }>
            selected?: {
              [key: string]: unknown
            }
            timeline?: Array<{
              [key: string]: unknown
            }>
            automations?: Array<{
              [key: string]: unknown
            }>
            jobs?: Array<{
              [key: string]: unknown
            }>
            changes?: Array<{
              [key: string]: unknown
            }>
            sync?: {
              clientID?: string
              serverCursor?: string | null
              lastPushAt?: number | null
              lastPullAt?: number | null
              pendingChanges?: number
            }
            webhooks?: Array<{
              [key: string]: unknown
            }>
            duplicates?: Array<{
              object: string
              field: string
              value: unknown
              count: number
            }>
            stages?: Array<{
              id: string
              label: string
            }>
          }
        | {
            id: string
            type: "generative"
            title?: string
            submitToolName: string
            uploadToolName: string
            uploadCommand: string
            policy: {
              enabled: boolean
              acknowledged: boolean
              disabledReason?: string | null
            }
            provider: {
              connected: boolean
            }
            catalog: {
              version: string
              source: string
              attribution: string
            }
            studios: Array<{
              id: string
              label: string
              defaultModelID: string
              models: Array<{
                [key: string]: unknown
              }>
            }>
            state: {
              [key: string]: unknown
            }
            assets: Array<{
              [key: string]: unknown
            }>
            jobs: Array<{
              [key: string]: unknown
            }>
            recipes?: Array<{
              [key: string]: unknown
            }>
            recipeRuns?: Array<{
              [key: string]: unknown
            }>
            brandDNA?: {
              activeID?: string | null
              profiles?: Array<{
                [key: string]: unknown
              }>
              commands?: {
                [key: string]: string
              }
            }
            campaigns?: {
              plans?: Array<{
                [key: string]: unknown
              }>
              commands?: {
                [key: string]: string
              }
            }
            pipelines?: {
              nodeTypes: Array<{
                [key: string]: unknown
              }>
              designs: Array<{
                [key: string]: unknown
              }>
              commands: {
                [key: string]: string
              }
            }
            traces?: Array<{
              [key: string]: unknown
            }>
            storage: {
              bytes: number
            }
            commands: {
              [key: string]: string
            }
            serverUrl?: string
          }
        | {
            id: string
            type: "artifact_editor"
            title?: string
            artifactPath: string
            html: string
            checksum: string
            qualityStatus: "unchecked" | "passed" | "failed"
            snapshots: Array<string>
            submitToolName: string
            visualUnavailableReason?: string
          }
        | {
            id: string
            type: "visual_pipeline"
            title?: string
            description?: string
            mode: "design"
            submitToolName: string
            graph: {
              schemaVersion: 1
              nodes: Array<{
                id: string
                type: string
                label: string
                position: {
                  x: number
                  y: number
                }
                data?: {
                  [key: string]: unknown
                }
              }>
              edges: Array<{
                id: string
                from: string
                to: string
                label?: string
                data?: {
                  [key: string]: unknown
                }
              }>
              viewport?: {
                x: number
                y: number
                zoom: number
              }
            }
            nodeTypes: Array<{
              type: string
              label: string
              description?: string
              category?: string
              icon?: string
              defaultData?: {
                [key: string]: unknown
              }
              fields?: Array<{
                key: string
                label: string
                type: "text" | "textarea" | "select" | "toggle" | "number"
                required?: boolean
                placeholder?: string
                description?: string
                min?: number
                max?: number
                step?: number
                options?: Array<
                  | string
                  | {
                      label: string
                      value: string
                    }
                >
              }>
            }>
            templates?: Array<{
              id: string
              label: string
              description?: string
              graph: {
                schemaVersion: 1
                nodes: Array<{
                  id: string
                  type: string
                  label: string
                  position: {
                    x: number
                    y: number
                  }
                  data?: {
                    [key: string]: unknown
                  }
                }>
                edges: Array<{
                  id: string
                  from: string
                  to: string
                  label?: string
                  data?: {
                    [key: string]: unknown
                  }
                }>
                viewport?: {
                  x: number
                  y: number
                  zoom: number
                }
              }
            }>
            validation?: {
              status: "valid" | "warning" | "error"
              messages?: Array<{
                id: string
                tone: "info" | "warning" | "error"
                message: string
                nodeId?: string
                edgeId?: string
              }>
            }
            exportActions?: Array<{
              command: "pipeline.export_markdown" | "pipeline.export_recipe"
              label: string
            }>
          }
        | {
            id: string
            type: "notice"
            title?: string
            message: string
            tone?: "info" | "success" | "warning" | "error"
            actions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
          }
        | {
            id: string
            type: "preview"
            title?: string
            mode: "html" | "markdown" | "url" | "json"
            content: unknown
            emptyState?: {
              title?: string
              description?: string
            }
          }
        | {
            id: string
            type: "registry"
            componentId: string
            version: string
            intent?: string
            title?: string
            span?: "auto" | "full"
            props?: {
              [key: string]: unknown
            }
            slots?: {
              [key: string]: unknown
            }
            actions?: Array<{
              id: string
              label: string
              toolName: string
              args?: {
                [key: string]: unknown
              }
              variant?: "primary" | "secondary" | "ghost"
              risk?: "read" | "local_write" | "external_write" | "destructive"
              confirm?: {
                title?: string
                description?: string
                sideEffect?: string
                reversibility?: string
                payloadSummary?: string
              }
              visibleWhen?: unknown
              disabledWhen?: unknown
              disabledReason?: string
              refreshWidgetIds?: Array<string>
              input?: {
                [key: string]: {
                  source: "view" | "block" | "row" | "values" | "args"
                  path: string
                  fallback?: unknown
                }
              }
            }>
            submitToolName?: string
            submits?: Array<{
              id: string
              label: string
              command: string
              variant?: "primary" | "secondary" | "ghost"
              disabledWhen?: unknown
              disabledReason?: string
            }>
          }
      position?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            {
              in: "path",
              key: "path_id",
              map: "id",
            },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            {
              in: "body",
              key: "body_id",
              map: "id",
            },
            { in: "body", key: "block" },
            { in: "body", key: "position" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      PluginUpsertDashboardWidgetResponses,
      PluginUpsertDashboardWidgetErrors,
      ThrowOnError
    >({
      url: "/plugin/apps/{id}/dashboard/widgets",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Delete a dynamic dashboard widget
   *
   * Remove a previously upserted widget for the current project + workspace.
   */
  public deleteDashboardWidget<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      widgetId: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "path", key: "widgetId" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).delete<
      PluginDeleteDashboardWidgetResponses,
      PluginDeleteDashboardWidgetErrors,
      ThrowOnError
    >({
      url: "/plugin/apps/{id}/dashboard/widgets/{widgetId}",
      ...options,
      ...params,
    })
  }

  /**
   * Execute a plugin page action
   *
   * Run an action declared inside the plugin page manifest.
   */
  public action<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      actionId: string
      directory?: string
      workspace?: string
      body?: unknown
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "path", key: "actionId" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "body", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginActionResponses, PluginActionErrors, ThrowOnError>({
      url: "/plugin/apps/{id}/action/{actionId}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Call a plugin app capability by name
   *
   * Execute a declared plugin app capability by name with args. Used by in-canvas interactions.
   */
  public call<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      toolName: string
      directory?: string
      workspace?: string
      body?: unknown
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "path", key: "toolName" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { key: "body", map: "body" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginCallResponses, PluginCallErrors, ThrowOnError>({
      url: "/plugin/apps/{id}/call/{toolName}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Execute a plugin artifact action
   *
   * Run an artifact action after revalidating the plugin page manifest and current artifact context.
   */
  public artifactAction<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      actionId: string
      directory?: string
      workspace?: string
      artifact?:
        | {
            type: "file"
            path: string
            mimeType?: string
            byteSize?: number
          }
        | {
            type: "selection"
            path: string
            text: string
            range?: {
              startLine: number
              endLine: number
            }
            mimeType?: string
          }
      values?: {
        [key: string]: unknown
      }
      confirmed?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "path", key: "actionId" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "artifact" },
            { in: "body", key: "values" },
            { in: "body", key: "confirmed" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      PluginArtifactActionResponses,
      PluginArtifactActionErrors,
      ThrowOnError
    >({
      url: "/plugin/apps/{id}/artifact-action/{actionId}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Submit a plugin page form
   *
   * Run a submit tool declared by a form block inside the plugin page manifest.
   */
  public submit<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      blockId: string
      directory?: string
      workspace?: string
      values?: {
        [key: string]: unknown
      }
      confirmed?: boolean
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "path", key: "blockId" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "values" },
            { in: "body", key: "confirmed" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginSubmitResponses, PluginSubmitErrors, ThrowOnError>({
      url: "/plugin/apps/{id}/submit/{blockId}",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Upload a plugin app file
   *
   * Upload a multipart file to a plugin block upload tool.
   */
  public upload<ThrowOnError extends boolean = false>(
    parameters: {
      id: string
      blockId: string
      directory?: string
      workspace?: string
      file?: Blob | File
      studio?: string
      kind?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "id" },
            { in: "path", key: "blockId" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "file" },
            { in: "body", key: "studio" },
            { in: "body", key: "kind" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<PluginUploadResponses, PluginUploadErrors, ThrowOnError>({
      ...formDataBodySerializer,
      url: "/plugin/apps/{id}/upload/{blockId}",
      ...options,
      ...params,
      headers: {
        "Content-Type": null,
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Instance extends HeyApiClient {
  /**
   * Dispose instance
   *
   * Clean up and dispose the current OpenAnalyst instance, releasing all resources.
   */
  public dispose<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<InstanceDisposeResponses, unknown, ThrowOnError>({
      url: "/instance/dispose",
      ...options,
      ...params,
    })
  }
}

export class Path extends HeyApiClient {
  /**
   * Get paths
   *
   * Retrieve the current working directory and related path information for the OpenAnalyst instance.
   */
  public get<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<PathGetResponses, unknown, ThrowOnError>({
      url: "/path",
      ...options,
      ...params,
    })
  }
}

export class Vcs extends HeyApiClient {
  /**
   * Get VCS info
   *
   * Retrieve version control system (VCS) information for the current project, such as git branch.
   */
  public get<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<VcsGetResponses, unknown, ThrowOnError>({
      url: "/vcs",
      ...options,
      ...params,
    })
  }

  /**
   * Get VCS diff
   *
   * Retrieve the current git diff for the working tree or against the default branch.
   */
  public diff<ThrowOnError extends boolean = false>(
    parameters: {
      directory?: string
      workspace?: string
      mode: "git" | "branch"
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "mode" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<VcsDiffResponses, unknown, ThrowOnError>({
      url: "/vcs/diff",
      ...options,
      ...params,
    })
  }
}

export class Command extends HeyApiClient {
  /**
   * List commands
   *
   * Get a list of all available commands in the OpenAnalyst system.
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<CommandListResponses, unknown, ThrowOnError>({
      url: "/command",
      ...options,
      ...params,
    })
  }
}

export class Lsp extends HeyApiClient {
  /**
   * Get LSP status
   *
   * Get LSP server status
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<LspStatusResponses, unknown, ThrowOnError>({
      url: "/lsp",
      ...options,
      ...params,
    })
  }
}

export class Formatter extends HeyApiClient {
  /**
   * Get formatter status
   *
   * Get formatter status
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<FormatterStatusResponses, unknown, ThrowOnError>({
      url: "/formatter",
      ...options,
      ...params,
    })
  }
}

export class Office extends HeyApiClient {
  /**
   * Get the live 10x office snapshot
   *
   * Read the reconciled Team Plan and sanitized factual office state for the current project.
   */
  public snapshot<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorOfficeSnapshotResponses,
      OrchestratorOfficeSnapshotErrors,
      ThrowOnError
    >({
      url: "/orchestrator/office/snapshot",
      ...options,
      ...params,
    })
  }

  /**
   * Page live 10x office facts
   *
   * Page the monotonic sanitized event cursor. Limit must be between 1 and 500.
   */
  public events<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      after?: string
      limit?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "after" },
            { in: "query", key: "limit" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorOfficeEventsResponses,
      OrchestratorOfficeEventsErrors,
      ThrowOnError
    >({
      url: "/orchestrator/office/events",
      ...options,
      ...params,
    })
  }
}

export class Draft extends HeyApiClient {
  /**
   * Watch a draft's phases
   */
  public progress<ThrowOnError extends boolean = false>(
    parameters: {
      draftID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "draftID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorWorkflowDraftProgressResponses,
      OrchestratorWorkflowDraftProgressErrors,
      ThrowOnError
    >({
      url: "/orchestrator/workflow/draft/{draftID}/progress",
      ...options,
      ...params,
    })
  }
}

export class Workflow extends HeyApiClient {
  /**
   * Inspect workflow
   *
   * Inspect and normalize the current project's workflow without approving it.
   */
  public inspect<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorWorkflowInspectResponses,
      OrchestratorWorkflowInspectErrors,
      ThrowOnError
    >({
      url: "/orchestrator/workflow/inspect",
      ...options,
      ...params,
    })
  }

  /**
   * Approve workflow candidate
   */
  public approve<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      candidate_hash?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "candidate_hash" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorWorkflowApproveResponses,
      OrchestratorWorkflowApproveErrors,
      ThrowOnError
    >({
      url: "/orchestrator/workflow/approve",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Read workflow source
   *
   * The project's WORKFLOW.md as it is on disk, with its content hash for compare-and-swap edits.
   */
  public source<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorWorkflowSourceResponses,
      OrchestratorWorkflowSourceErrors,
      ThrowOnError
    >({
      url: "/orchestrator/workflow/source",
      ...options,
      ...params,
    })
  }

  /**
   * Write workflow source
   *
   * Replace WORKFLOW.md (compare-and-swap on base_sha256). Writing never activates: it creates a new candidate and pauses new dispatch until a human approves the new hash.
   */
  public sourceUpdate<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      source?: string
      base_sha256?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "source" },
            { in: "body", key: "base_sha256" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).put<
      OrchestratorWorkflowSourceUpdateResponses,
      OrchestratorWorkflowSourceUpdateErrors,
      ThrowOnError
    >({
      url: "/orchestrator/workflow/source",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Validate workflow source
   *
   * Run the workflow loader over the given source without writing anything.
   */
  public validate<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      source?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "source" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorWorkflowValidateResponses,
      OrchestratorWorkflowValidateErrors,
      ThrowOnError
    >({
      url: "/orchestrator/workflow/validate",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Draft a workflow from a task description
   *
   * Two-phase generation: design the state machine from the goal, then write each role's instructions with a dedicated subagent call. Returns validated source; never writes or activates anything.
   */
  public draft<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      goal?: string
      context?: string
      roles_hint?: number | "NaN" | "Infinity" | "-Infinity" | "Infinity" | "-Infinity" | "NaN"
      effort?: string
      answers?: Array<{
        question: string
        answer: string
      }>
      draft_id?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "goal" },
            { in: "body", key: "context" },
            { in: "body", key: "roles_hint" },
            { in: "body", key: "effort" },
            { in: "body", key: "answers" },
            { in: "body", key: "draft_id" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorWorkflowDraftResponses,
      OrchestratorWorkflowDraftErrors,
      ThrowOnError
    >({
      url: "/orchestrator/workflow/draft",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  private _draft?: Draft
  get draft2(): Draft {
    return (this._draft ??= new Draft({ client: this.client }))
  }
}

export class Handoff extends HeyApiClient {
  /**
   * Retry a failed automatic handoff
   *
   * Records one human retry request and wakes the single project supervisor. The supervisor remains the only component allowed to create the child, preserving chain idempotency and preventing duplicate handoff tickets.
   */
  public retry<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorTicketHandoffRetryResponses,
      OrchestratorTicketHandoffRetryErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets/{ticketID}/handoff/retry",
      ...options,
      ...params,
    })
  }
}

export class Capability extends HeyApiClient {
  /**
   * Resolve a denied ticket input safely
   *
   * Copies the exact denied project file into this ticket's approved input folder. It never moves, overwrites, stages credentials, or broadens workflow authority.
   */
  public resolve<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
      action?: "stage_input"
      event_seq?: number | "NaN" | "Infinity" | "-Infinity" | "Infinity" | "-Infinity" | "NaN"
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "action" },
            { in: "body", key: "event_seq" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorTicketCapabilityResolveResponses,
      OrchestratorTicketCapabilityResolveErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets/{ticketID}/capability-resolution",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Artifact extends HeyApiClient {
  /**
   * Promote an accepted artifact
   *
   * Authenticated host action that copies one accepted ticket artifact into output/drafts. It never broadens agent write access and never overwrites a different file.
   */
  public promote<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
      source_path?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "source_path" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorTicketArtifactPromoteResponses,
      OrchestratorTicketArtifactPromoteErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets/{ticketID}/promote-artifact",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Memory extends HeyApiClient {
  /**
   * Save one reviewed ticket learning
   *
   * Authenticated human action that stores one confirmed durable statement in a selected project layer or 10x Memory. Ticket agents cannot call this endpoint or write memory themselves.
   */
  public promote<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
      statement?: string
      type?: "project-config" | "architecture" | "error-solution" | "preference" | "learned-pattern"
      scope?: "project" | "workspace"
      destination?: "project_knowledge" | "project_context" | "project_strategy" | "project_learnings" | "tenx_memory"
      evidence_paths?: Array<string>
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "statement" },
            { in: "body", key: "type" },
            { in: "body", key: "scope" },
            { in: "body", key: "destination" },
            { in: "body", key: "evidence_paths" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorTicketMemoryPromoteResponses,
      OrchestratorTicketMemoryPromoteErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets/{ticketID}/promote-memory",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }
}

export class Ticket extends HeyApiClient {
  /**
   * List tickets
   */
  public list<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorTicketListResponses,
      OrchestratorTicketListErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets",
      ...options,
      ...params,
    })
  }

  /**
   * Create ticket
   */
  public create<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      identifier?: string
      title?: string
      description?: string
      acceptance_criteria?: Array<{
        id?: string
        text: string
      }>
      initial_state?: string
      role_id?: string
      assignee?: string
      priority?: number
      model?: {
        provider_id: string
        model_id: string
      }
      dependency_ticket_ids?: Array<string>
      helper_grant?: {
        profile_ids: Array<string>
        max_executions: number
        max_concurrent: number
        max_total_wall_clock_seconds: number
        max_total_tokens: number
        max_total_output_bytes: number
        max_total_cost_microusd?: number
      }
      learning?: {
        capture?: "off" | "attempts" | "attempts_and_retrospective"
        consume?: "off" | "on"
      }
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "identifier" },
            { in: "body", key: "title" },
            { in: "body", key: "description" },
            { in: "body", key: "acceptance_criteria" },
            { in: "body", key: "initial_state" },
            { in: "body", key: "role_id" },
            { in: "body", key: "assignee" },
            { in: "body", key: "priority" },
            { in: "body", key: "model" },
            { in: "body", key: "dependency_ticket_ids" },
            { in: "body", key: "helper_grant" },
            { in: "body", key: "learning" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorTicketCreateResponses,
      OrchestratorTicketCreateErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Get ticket
   */
  public get<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorTicketGetResponses,
      OrchestratorTicketGetErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets/{ticketID}",
      ...options,
      ...params,
    })
  }

  /**
   * Request a human ticket transition
   *
   * Request a transition declared with actor `human`. Agent-requested transitions stay unavailable here; the authenticated request itself satisfies `explicit_approval`, and every other declared gate is still evaluated by the host.
   */
  public transition<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
      transition_id?: string
      expected_version?: number | "NaN" | "Infinity" | "-Infinity" | "Infinity" | "-Infinity" | "NaN"
      reason?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "transition_id" },
            { in: "body", key: "expected_version" },
            { in: "body", key: "reason" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorTicketTransitionResponses,
      OrchestratorTicketTransitionErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets/{ticketID}/transition",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Ask a blocked ticket to try again
   *
   * A blocked ticket is held out of the dispatch queue until a person answers the blocker. This records that answer and clears the blockers the agent wrote, so the next attempt starts from a workpad that no longer parks itself.
   */
  public retry<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<
      OrchestratorTicketRetryResponses,
      OrchestratorTicketRetryErrors,
      ThrowOnError
    >({
      url: "/orchestrator/tickets/{ticketID}/retry",
      ...options,
      ...params,
    })
  }

  private _handoff?: Handoff
  get handoff(): Handoff {
    return (this._handoff ??= new Handoff({ client: this.client }))
  }

  private _capability?: Capability
  get capability(): Capability {
    return (this._capability ??= new Capability({ client: this.client }))
  }

  private _artifact?: Artifact
  get artifact(): Artifact {
    return (this._artifact ??= new Artifact({ client: this.client }))
  }

  private _memory?: Memory
  get memory(): Memory {
    return (this._memory ??= new Memory({ client: this.client }))
  }
}

export class Channels2 extends HeyApiClient {
  /**
   * Inbound channel ledger
   *
   * Every message a channel delivered to this project and the dispatcher's verdict on it.
   */
  public inbox<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      limit?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "limit" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorChannelsInboxResponses,
      OrchestratorChannelsInboxErrors,
      ThrowOnError
    >({
      url: "/orchestrator/channels/inbox",
      ...options,
      ...params,
    })
  }

  /**
   * Outbound channel ledger
   */
  public outbox<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      limit?: number
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "query", key: "limit" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorChannelsOutboxResponses,
      OrchestratorChannelsOutboxErrors,
      ThrowOnError
    >({
      url: "/orchestrator/channels/outbox",
      ...options,
      ...params,
    })
  }

  /**
   * One ticket's channel traffic
   */
  public ticket<ThrowOnError extends boolean = false>(
    parameters: {
      ticketID: string
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "path", key: "ticketID" },
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorChannelsTicketResponses,
      OrchestratorChannelsTicketErrors,
      ThrowOnError
    >({
      url: "/orchestrator/channels/ticket/{ticketID}",
      ...options,
      ...params,
    })
  }

  /**
   * Channel status
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorChannelsStatusResponses,
      OrchestratorChannelsStatusErrors,
      ThrowOnError
    >({
      url: "/orchestrator/channels/status",
      ...options,
      ...params,
    })
  }
}

export class Orchestrator extends HeyApiClient {
  /**
   * Get orchestrator status
   *
   * Get redacted capability, dependency, budget, and research status for the current project.
   */
  public status<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<OrchestratorStatusResponses, OrchestratorStatusErrors, ThrowOnError>({
      url: "/orchestrator/status",
      ...options,
      ...params,
    })
  }

  /**
   * Get active Team Plan
   *
   * Read immutable office-safe role, character, helper-limit, chain, and state metadata.
   */
  public teamPlan<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorTeamPlanResponses,
      OrchestratorTeamPlanErrors,
      ThrowOnError
    >({
      url: "/orchestrator/team-plan",
      ...options,
      ...params,
    })
  }

  /**
   * Enable orchestrator
   */
  public enable<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      candidate_hash?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "candidate_hash" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<OrchestratorEnableResponses, OrchestratorEnableErrors, ThrowOnError>({
      url: "/orchestrator/enable",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Pause orchestrator
   */
  public pause<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
      reason?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
            { in: "body", key: "reason" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<OrchestratorPauseResponses, OrchestratorPauseErrors, ThrowOnError>({
      url: "/orchestrator/pause",
      ...options,
      ...params,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
        ...params.headers,
      },
    })
  }

  /**
   * Resume orchestrator
   */
  public resume<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<OrchestratorResumeResponses, OrchestratorResumeErrors, ThrowOnError>({
      url: "/orchestrator/resume",
      ...options,
      ...params,
    })
  }

  /**
   * Disable orchestrator
   */
  public disable<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).post<OrchestratorDisableResponses, OrchestratorDisableErrors, ThrowOnError>(
      {
        url: "/orchestrator/disable",
        ...options,
        ...params,
      },
    )
  }

  /**
   * Per-role learnings
   *
   * Group this project's recorded run evidence by role: gates repeatedly missed, peak capability usage, and whether failures were the agent's or the host's. Deterministic — it reports what happened and proposes nothing.
   */
  public learnings<ThrowOnError extends boolean = false>(
    parameters?: {
      directory?: string
      workspace?: string
    },
    options?: Options<never, ThrowOnError>,
  ) {
    const params = buildClientParams(
      [parameters],
      [
        {
          args: [
            { in: "query", key: "directory" },
            { in: "query", key: "workspace" },
          ],
        },
      ],
    )
    return (options?.client ?? this.client).get<
      OrchestratorLearningsResponses,
      OrchestratorLearningsErrors,
      ThrowOnError
    >({
      url: "/orchestrator/learnings",
      ...options,
      ...params,
    })
  }

  private _office?: Office
  get office(): Office {
    return (this._office ??= new Office({ client: this.client }))
  }

  private _workflow?: Workflow
  get workflow(): Workflow {
    return (this._workflow ??= new Workflow({ client: this.client }))
  }

  private _ticket?: Ticket
  get ticket(): Ticket {
    return (this._ticket ??= new Ticket({ client: this.client }))
  }

  private _channels?: Channels2
  get channels(): Channels2 {
    return (this._channels ??= new Channels2({ client: this.client }))
  }
}

export class OpenAnalystClient extends HeyApiClient {
  public static readonly __registry = new HeyApiRegistry<OpenAnalystClient>()

  constructor(args?: { client?: Client; key?: string }) {
    super(args)
    OpenAnalystClient.__registry.set(this, args?.key)
  }

  private _global?: Global
  get global(): Global {
    return (this._global ??= new Global({ client: this.client }))
  }

  private _app?: App
  get app(): App {
    return (this._app ??= new App({ client: this.client }))
  }

  private _auth?: Auth
  get auth(): Auth {
    return (this._auth ??= new Auth({ client: this.client }))
  }

  private _experimental?: Experimental
  get experimental(): Experimental {
    return (this._experimental ??= new Experimental({ client: this.client }))
  }

  private _project?: Project
  get project(): Project {
    return (this._project ??= new Project({ client: this.client }))
  }

  private _reflect?: Reflect
  get reflect(): Reflect {
    return (this._reflect ??= new Reflect({ client: this.client }))
  }

  private _pty?: Pty
  get pty(): Pty {
    return (this._pty ??= new Pty({ client: this.client }))
  }

  private _config?: Config2
  get config(): Config2 {
    return (this._config ??= new Config2({ client: this.client }))
  }

  private _tool?: Tool
  get tool(): Tool {
    return (this._tool ??= new Tool({ client: this.client }))
  }

  private _worktree?: Worktree
  get worktree(): Worktree {
    return (this._worktree ??= new Worktree({ client: this.client }))
  }

  private _session?: Session2
  get session(): Session2 {
    return (this._session ??= new Session2({ client: this.client }))
  }

  private _part?: Part
  get part(): Part {
    return (this._part ??= new Part({ client: this.client }))
  }

  private _permission?: Permission
  get permission(): Permission {
    return (this._permission ??= new Permission({ client: this.client }))
  }

  private _question?: Question
  get question(): Question {
    return (this._question ??= new Question({ client: this.client }))
  }

  private _provider?: Provider
  get provider(): Provider {
    return (this._provider ??= new Provider({ client: this.client }))
  }

  private _transcription?: Transcription
  get transcription(): Transcription {
    return (this._transcription ??= new Transcription({ client: this.client }))
  }

  private _sync?: Sync
  get sync(): Sync {
    return (this._sync ??= new Sync({ client: this.client }))
  }

  private _onboarding?: Onboarding
  get onboarding(): Onboarding {
    return (this._onboarding ??= new Onboarding({ client: this.client }))
  }

  private _find?: Find
  get find(): Find {
    return (this._find ??= new Find({ client: this.client }))
  }

  private _file?: File
  get file(): File {
    return (this._file ??= new File({ client: this.client }))
  }

  private _event?: Event
  get event(): Event {
    return (this._event ??= new Event({ client: this.client }))
  }

  private _mcp?: Mcp2
  get mcp(): Mcp2 {
    return (this._mcp ??= new Mcp2({ client: this.client }))
  }

  private _tui?: Tui
  get tui(): Tui {
    return (this._tui ??= new Tui({ client: this.client }))
  }

  private _plugin?: Plugin
  get plugin(): Plugin {
    return (this._plugin ??= new Plugin({ client: this.client }))
  }

  private _instance?: Instance
  get instance(): Instance {
    return (this._instance ??= new Instance({ client: this.client }))
  }

  private _path?: Path
  get path(): Path {
    return (this._path ??= new Path({ client: this.client }))
  }

  private _vcs?: Vcs
  get vcs(): Vcs {
    return (this._vcs ??= new Vcs({ client: this.client }))
  }

  private _command?: Command
  get command(): Command {
    return (this._command ??= new Command({ client: this.client }))
  }

  private _lsp?: Lsp
  get lsp(): Lsp {
    return (this._lsp ??= new Lsp({ client: this.client }))
  }

  private _formatter?: Formatter
  get formatter(): Formatter {
    return (this._formatter ??= new Formatter({ client: this.client }))
  }

  private _orchestrator?: Orchestrator
  get orchestrator(): Orchestrator {
    return (this._orchestrator ??= new Orchestrator({ client: this.client }))
  }
}
